// import React, { useState, useEffect, useCallback, useRef } from "react";
// import {
//   useNavigate,
//   useParams,
//   useLocation,
//   useMatch,
// } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { Spin, Skeleton, message, Button, Table, Tag, Modal } from "antd";
// import { IoArrowBackCircleOutline } from "react-icons/io5";
// import { HiOutlineArrowRight } from "react-icons/hi2";
// import { FiUsers, FiDownload, FiBarChart2 } from "react-icons/fi";
// import { MdGppGood, MdOutlineAccountTree } from "react-icons/md";
// import { GoShieldCheck } from "react-icons/go";
// import {
//   fetchFormAssignments,
//   fetchFormDetails,
//   clearStatus,
//   resetViewFormState,
//   fetchProjectById,
// } from "../../../../redux/ViewForm/viewFormSlice";
// import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
// import { QuestionForm } from "./questionForm";
// import AuthorizeToManage from "../Projects/ProjectPage/AuthorizeToManage";
// import AuthorizeToManageLS2 from "../Projects/ProjectPage/AuthorizeToManageLS2";
// import AssignFormDetail from "./AssignFormDetail";
// import AssignFormPage from "../Projects/ProjectPage/AssignFormPage";
// import PopupCard from "../../../Auth/PopupCard";
// import QuestionUtils from "./components/QuestionUtils";
// import StandardFormAction from "./StandardFormAction";
// import { ArrowUpOutlined, SaveOutlined } from "@ant-design/icons";

// import { ReactComponent as Back } from "../../../../assets/svgs/back-button.svg";
// import { getApi } from "../../../../api/api_instance";

// import { SearchBar } from "../../../../components/Elements/Search/SearchBar";

// import { API_URLS } from "../../../../api/apiUrls";

// const ViewStandardForm = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { formId } = useParams();
//   const location = useLocation();
//   const isStandardViewRoute = Boolean(
//     useMatch("/organization/projects/standard-forms/view/:formId"),
//   );
//   const isEmployeeRoute = location.pathname.startsWith("/employee");
//   const getDisplayValue = (val) => {
//     if (!val) return "";
//     if (typeof val === "string" || typeof val === "number") return String(val);
//     if (typeof val === "object") {
//       return (
//         val.name ||
//         val.projectName ||
//         val.formName ||
//         val.title ||
//         val._id ||
//         ""
//       );
//     }
//     return "";
//   };
//   const { formId: allotmentId } = useParams();

//   const id = allotmentId || allotmentIdFromState;
//   const {
//     formName,
//     formTitle,
//     projectId,
//     formId: passedFormId,
//     formType: passedFormType,
//     allotmentType: passedAllotmentType,
//     source,
//     manageLevel,
//     roleType,
//     locationId,
//     departmentId,
//     locationIdRaw,
//     departmentIdRaw,
//     formAllotmentId,
//     allottedByRole,
//     progress,

//     frequecy,
//     periods,
//     userId,
//     templateId,
//     id: allotmentIdFromState,
//     formIdRaw,
//   } = location.state || {};

//   console.log(formIdRaw, " formIdRaw----formIdRaw---------formIdRaw");
//   const resolvedFormAllotmentId =
//     formAllotmentId || (isEmployeeRoute ? formId : "");

//   // If manageLevel is not passed but roleType is, use roleType as the manageLevel
//   // const currentManageLevel = manageLevel !== undefined ? manageLevel : roleType;
//   console.log(formName, "formasjdkadsk");
//   // Redux State
//   const authUser = useSelector((state) => state.auth.user);
//   const orgModeLocked = authUser?.orgModeLocked || false;
//   console.log("orgModeLocked in ViewStandardForm:", orgModeLocked);

//   const [sections, setSections] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [selectedSection, setSelectedSection] = useState(null);
//   const [subsections, setSubsections] = useState([]);
//   const [selectedSubsection, setSelectedSubsection] = useState(null);
//   const [questions, setQuestions] = useState([]);
//   const [answers, setAnswers] = useState({});

//   const [currentSubsectionIndex, setCurrentSubsectionIndex] = useState(0);
//   const [searchTerm, setSearchTerm] = useState("");
//   const pageSize = 100;

//   const [expandAll, setExpandAll] = useState(false);
//   const [showGoTop, setShowGoTop] = useState(false);
//   {
//     /* Add these two states at the top with other states */
//   }
//   const [showMappingWarning, setShowMappingWarning] = useState(false);
//   const [mappingStats, setMappingStats] = useState({ total: 0, mapped: 0 });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageLimit, setPageLimit] = useState(10);
//   const scrollableContainerRef = useRef(null);

//   const scrollableContainer = {
//     maxHeight: "1000px",
//     overflowY: "auto",
//     padding: "10px",
//     borderRadius: "8px",
//   };
//   const shouldUseLs2 = location.pathname.startsWith("/employee");
//   const {
//     assignments,
//     assignmentsTotal, // ← add these
//     assignmentsLimit,
//     assignmentsSkip,
//     details,
//     projectDetails,
//     loading: reduxLoading,
//     error: reduxError,
//   } = useSelector((state) => state.viewForm);
//   console.log(projectDetails, "nowwwwwwwwprojectDetails in ViewStandardForm");
//   const projectdetailslicense =
//     projectDetails?.license.local_supervisor?.unused == 0 || {};
//   console.log(
//     projectdetailslicense,
//     "projectDetails in 1111111111111111111111111111111111",
//   );

//   // Local State
//   const [activeTab, setActiveTab] = useState("Form Structure");
//   const [openModal, setOpenModal] = useState(null); // 'authorize' or 'assign'
//   const [popupConfig, setPopupConfig] = useState(null); // { type, title, message, confirmText }

//   const safeProgress = progress || {};
//   console.log("Progress data in ViewStandardForm:ggghhghg", safeProgress);
//   const total = safeProgress.totalRecipients || 0;

//   const progressStats = isEmployeeRoute
//     ? {
//         // ✅ Employee (already correct format)
//         totalAssigned: progress?.totalRecipients || 0,
//         completedPercent: progress?.overallPercentage || 0,
//         inProgressPercent: progress?.inProgress || 0,
//         pendingPercent: progress?.notStarted || 0,
//         completedCount: progress?.completed || 0,
//         inProgressCount: progress?.inProgress || 0,
//         pendingCount: progress?.notStarted || 0,
//       }
//     : {
//         //customer admin
//         totalAssigned: progress?.totalRecipients || 0,
//         completedPercent: progress?.overallPercentage || 0,
//         inProgressPercent: progress?.inProgress || 0,
//         pendingPercent: progress?.notStarted || 0,
//         completedCount: progress?.completed || 0,
//         inProgressCount: progress?.inProgress || 0,
//         pendingCount: progress?.notStarted || 0,
//       };

//   // const progressStats = {
//   // totalAssigned: progress?.totalRecipients || 0,
//   // completedPercent: progress?.overallPercentage || 0,
//   // inProgressPercent: progress?.inProgress || 0,
//   // pendingPercent: progress?.notStarted || 0,
//   // completedCount: progress?.completed || 0,
//   // inProgressCount: progress?.inProgress || 0,
//   // pendingCount: progress?.notStarted || 0,
//   // };

//   const fetchedFormIdRef = useRef(null);

//   // useEffect(() => {
//   //   // ✅ formIdRaw employee ke liye, passedFormId/templateId/formId customer admin ke liye
//   //   const resolvedFormId = formIdRaw || passedFormId || templateId || formId;

//   //   if (resolvedFormId) {
//   //     console.log("Fetching assignments for:", resolvedFormId, "isEmployee:", isEmployeeRoute);
//   //     fetchedFormIdRef.current = resolvedFormId;
//   //     dispatch(fetchFormAssignments({
//   //       formId: resolvedFormId,
//   //       isEmployee: isEmployeeRoute,
//   //       skip: 0,
//   //       limit: 10,
//   //     }));
//   //   }

//   //   if (isStandardViewRoute && projectId) {
//   //     dispatch(fetchProjectById(projectId));
//   //   }

//   //   return () => {
//   //     dispatch(resetViewFormState());
//   //   };
//   // }, [dispatch, formIdRaw, passedFormId, templateId, formId, projectId]);

//   // ✅ useEffect ke BAHAR — pehle define karo
//   const fetchAssignments = useCallback(
//     (page, limit) => {
//       const resolvedFormId = formIdRaw || passedFormId || templateId || formId;
//       if (!resolvedFormId) return;
//       const skip = (page - 1) * limit;
//       dispatch(
//         fetchFormAssignments({
//           formId: resolvedFormId,
//           isEmployee: isEmployeeRoute,
//           skip,
//           limit,
//         }),
//       );
//     },
//     [dispatch, formIdRaw, passedFormId, templateId, formId, isEmployeeRoute],
//   );

//   // ✅ useEffect mein sirf call karo
//   useEffect(() => {
//     fetchAssignments(1, pageLimit);

//     if (isStandardViewRoute && projectId) {
//       dispatch(fetchProjectById(projectId));
//     }

//     return () => {
//       dispatch(resetViewFormState());
//     };
//   }, [fetchAssignments, projectId]); // fetchAssignments dependency mein dena

//   useEffect(() => {
//     const handleContainerScroll = () => {
//       if (scrollableContainerRef.current) {
//         const scrollTop = scrollableContainerRef.current.scrollTop;
//         setShowGoTop((prev) => prev || scrollTop > 200);
//       }
//     };

//     const containerElement = scrollableContainerRef.current;
//     if (containerElement) {
//       containerElement.addEventListener("scroll", handleContainerScroll);
//       return () =>
//         containerElement.removeEventListener("scroll", handleContainerScroll);
//     }
//   }, [questions, selectedSubsection]);

//   const fetchSections = async () => {
//     setLoading(true);
//     try {
//       const response = await getApi(
//         {
//           apiUrl: API_URLS.GET_GET_STANDARD_FORM_Section(id),
//         },
//         true,
//       );

//       if (response.success) {
//         if (response.data.sections.length > 0) {
//           const firstSection = response.data.sections[0];
//           setSections(response.data.sections);
//           setSelectedSection(firstSection.sectionId);
//           await fetchSubsections(firstSection.sectionId);
//         }
//       } else {
//         console.error("Failed to fetch sections");
//       }
//     } catch (error) {
//       console.error("Error fetching sections", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchSubsections = async (sectionId) => {
//     setLoading(true);
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_GET_STANDARD_FORM_Subsection(id, sectionId),
//       });

//       if (response.success) {
//         setSubsections(response.data.subsections);
//         setSelectedSection(sectionId);

//         if (response.data.subsections.length > 0) {
//           const firstSubsection = response.data.subsections[0];
//           setSelectedSubsection(firstSubsection.subsectionId);
//           // Pass the IDs directly instead of relying on state
//           await fetchQuestions(sectionId, firstSubsection.subsectionId);
//         } else {
//           setQuestions([]);
//         }
//       } else {
//         console.error("Failed to fetch subsections");
//         setSubsections([]);
//         setQuestions([]);
//       }
//     } catch (error) {
//       console.error("Error fetching subsections", error);
//       setSubsections([]);
//       setQuestions([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchQuestions = async (sectionId, subsectionId) => {
//     // Use parameters instead of state
//     const section = sectionId || selectedSection;
//     const subsection = subsectionId || selectedSubsection;

//     console.log("Fetching questions for:", { section, subsection });

//     if (!section || !subsection) {
//       console.log("Missing section or subsection ID");
//       return;
//     }

//     setLoading(true);
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_GET_STANDARD_FORM_Questions(
//           id,
//           section,
//           subsection,
//         ),
//       });

//       console.log("Questions response:", response);

//       if (response.success) {
//         let divisions = response.data.divisions || [];
//         setQuestions(divisions);
//         console.log("Divisions set:", divisions);
//       } else {
//         setQuestions([]);
//       }
//     } catch (error) {
//       console.error("Error fetching questions", error);
//       message.error("Failed to fetch questions");
//       setQuestions([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const scrollToTop = () => {
//     if (scrollableContainerRef.current) {
//       scrollableContainerRef.current.scrollTop = 0;
//     }
//     window.scrollTo({ top: 0, behavior: "smooth" });
//     setShowGoTop(false);
//   };

//   const handleSubsectionClick = (subsectionId) => {
//     const index = subsections.findIndex((s) => s.subsectionId === subsectionId);
//     if (index !== -1) {
//       setCurrentSubsectionIndex(index);
//     }
//     setSelectedSubsection(subsectionId);
//     fetchQuestions(selectedSection, subsectionId);
//   };

//   const handlePrevious = () => {
//     if (currentSubsectionIndex > 0) {
//       const newIndex = currentSubsectionIndex - 1;
//       const prevSub = subsections[newIndex];
//       setCurrentSubsectionIndex(newIndex);
//       setSelectedSubsection(prevSub.subsectionId);
//       fetchQuestions(selectedSection, prevSub.subsectionId);
//       scrollToTop();
//     }
//   };

//   const handleNext = async () => {
//     const isLast = currentSubsectionIndex >= subsections.length - 1;

//     if (!isLast) {
//       const newIndex = currentSubsectionIndex + 1;
//       const nextSub = subsections[newIndex];
//       setCurrentSubsectionIndex(newIndex);
//       setSelectedSubsection(nextSub.subsectionId);
//       fetchQuestions(selectedSection, nextSub.subsectionId);
//       scrollToTop();
//     } else {
//       message.success("Subsection navigation complete.");
//     }
//   };

//   // Error handling with PopupCard
//   useEffect(() => {
//     if (reduxError) {
//       setPopupConfig({
//         type: "error",
//         title: "Error Occurred",
//         message: reduxError,
//         confirmText: "Close",
//       });
//       dispatch(clearStatus());
//     }
//   }, [reduxError, dispatch]);

//   // Use Redux assignments data with mapping for API response keys
//   // const tableData = (assignments || []).map((item) => ({
//   //   ...item,
//   //   key: item.allotmentId || item._id,
//   //   type:
//   //     item.allotmentType
//   //       ? item.allotmentType.charAt(0).toUpperCase() + item.allotmentType.slice(1)
//   //       : "N/A",
//   //   level: item.sections?.length > 0 ? "Section" : "N/A",
//   //   scope:
//   //     item.sections?.map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join(", ") ||
//   //     "-",
//   //   assignedTo: item.employee?.name || "N/A",
//   //   assignedBy: item.allottedBy || "Admin",
//   //   status: item.status || "Assigned",
//   //   endDate: item.expiresAt ? new Date(item.expiresAt).toLocaleDateString() : "-",
//   // }));
//   const tableData = (assignments || []).map((item) => ({
//     ...item,
//     key: item.allotmentId || item._id,

//     type: item.allotmentType
//       ? item.allotmentType.charAt(0).toUpperCase() + item.allotmentType.slice(1)
//       : "N/A",

//     // ✅ Use API level directly
//     level: item.level || "N/A",

//     // ✅ Format sections nicely
//     scope: item?.locationId?.name,
//     // scope:
//     // item?.departmentId?.name,

//     assignedTo: item.employee?.name || "N/A",

//     // ✅ FIXED (was wrong before)
//     assignedBy: item.assignedBy?.name || "Admin",

//     status: item.status || "Assigned",

//     // ✅ FIXED (use endDate from API)
//     endDate: item.endDate ? new Date(item.endDate).toLocaleDateString() : "-",
//   }));

//   const getStatusColor = (status) => {
//     switch (status) {
//       case "Active":
//         return "#E6F4EA"; // Green
//       case "In Progress":
//         return "#FEF7E0"; // Yellow
//       case "Completed":
//         return "#E8F0FE"; // Blue
//       case "Paused":
//         return "#FCE8E6"; // Red
//       case "Revoked":
//         return "#F1F3F4"; // Gray
//       default:
//         return "#F1F3F4";
//     }
//   };

//   const getStatusTextColor = (status) => {
//     switch (status) {
//       case "Active":
//         return "#137333";
//       case "In Progress":
//         return "#B06000";
//       case "Completed":
//         return "#1967D2";
//       case "Paused":
//         return "#C5221F";
//       case "Revoked":
//         return "#5F6368";
//       default:
//         return "#5F6368";
//     }
//   };

//   const columns = [
//     {
//       title: "TYPE",
//       dataIndex: "type",
//       key: "type",
//       render: (text) => (
//         <span className="font-medium text-gray-400">{text}</span>
//       ),
//     },
//     {
//       title: "LEVEL",
//       dataIndex: "level",
//       key: "level",
//       render: (text) => <span className="text-gray-400">{text}</span>,
//     },
//     {
//       title: "SCOPE",
//       dataIndex: "scope",
//       key: "scope",
//       render: (text) => (
//         <span className="font-medium text-gray-800">{text}</span>
//       ),
//     },
//     {
//       title: "ASSIGNED TO",
//       dataIndex: "assignedTo",
//       key: "assignedTo",
//       render: (text) => <span className="text-gray-400">{text}</span>,
//     },
//     {
//       title: "ASSIGNED BY",
//       dataIndex: "assignedBy",
//       key: "assignedBy",
//       render: (text) => <span className="text-gray-400">{text}</span>,
//     },
//     {
//       title: "STATUS",
//       dataIndex: "status",
//       key: "status",
//       render: (status) => (
//         <Tag
//           style={{
//             backgroundColor: getStatusColor(status),
//             color: getStatusTextColor(status),
//             border: `1px solid ${getStatusTextColor(status)}30`,
//             borderRadius: "8px",
//             padding: "2px 16px",
//             fontWeight: "700",
//             fontSize: "11px",
//             width: "100px",
//             textAlign: "center",
//           }}
//         >
//           {status}
//         </Tag>
//       ),
//     },
//     {
//       title: "END DATE",
//       dataIndex: "endDate",
//       key: "endDate",
//       render: (text) => (
//         <span className="text-gray-400 font-medium">{text}</span>
//       ),
//     },
//     {
//       title: "ACTIONS",
//       key: "actions",
//       render: () => (
//         <span className="text-gray-800 font-bold cursor-pointer hover:text-gray-600 px-2 transition">
//           ?
//         </span>
//       ),
//     },
//   ];

//   return (
//     <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       {/* Header Breadcrumb */}

//       <div className="flex flex-wrap justify-end text-[10px] h-5 font-medium gap-1 sm:gap-2 text-gray-400">
//         <p>Home</p>
//         <span>/</span>
//         <p>Projects</p>
//         <span>/</span>
//         <p>Project Details Page</p>
//         <span>/</span>
//         <TextStyles style={{ color: "#06513D", fontSize: "10px" }}>
//           Form Details Page
//         </TextStyles>
//       </div>
//       <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
//         <IoArrowBackCircleOutline
//           onClick={() => navigate(-1)}
//           className="w-8 h-8 text-[#06513D] hover:scale-105 transition cursor-pointer"
//         />

//         <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
//           Form Details Page
//         </div>
//       </div>

//       {/* Premium Info Card - BASIC DETAILS FORM */}
//       <div className="bg-white border border-[#38A28D]  rounded-md shadow-sm mb-6 overflow-hidden">
//         <div className="px-6 py-4 border-b border-gray-100">
//           <h2 className="text-lg font-bold text-gray-800 tracking-tight uppercase">
//             {getDisplayValue(location.state?.formTitle) ||
//               "Carbon Reduction Initiative"}
//           </h2>
//         </div>
//         <div className="p-6">
//           <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
//             <div className="space-y-1">
//               <p className="text-[15px]  text-[#595F61] uppercase tracking-wider">
//                 PROJECT
//               </p>
//               <p className="text-sm font-bold text-gray-800">
//                 {getDisplayValue(
//                   projectDetails?.name || location.state?.projectName,
//                 ) || "N/A"}
//               </p>
//             </div>
//             <div className="space-y-1">
//               <p className="text-[15px]  text-[#595F61] uppercase tracking-wider">
//                 FREQUENCY
//               </p>
//               <p className="text-sm font-bold text-gray-800">
//                 {(() => {
//                   const currentFormId = passedFormId || templateId || formId;
//                   const allForms = [
//                     ...(projectDetails?.standard_form || []),
//                     ...(projectDetails?.dynamic_form || []),
//                     ...(projectDetails?.custom_form || []),
//                   ];
//                   const match = allForms.find((f) => f.id === currentFormId);
//                   return match?.frequency || frequecy || "N/A";
//                 })()}
//               </p>
//             </div>
//             <div className="space-y-1">
//               <p className="text-[15px]  text-[#595F61] uppercase tracking-wider">
//                 PERIOD
//               </p>
//               <p className="text-sm font-bold text-gray-800">
//                 {projectDetails?.year_value || periods || "N/A"}
//               </p>
//             </div>
//             {/* <div className="space-y-1">
//               <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
//                 END DATE
//               </p>
//               <p className="text-sm font-bold text-gray-800">
//                 {details?.endDate || "29 March 2026"}
//               </p>
//             </div> */}
//             <div className="space-y-1">
//               <p className="text-[15px]  text-[#595F61] uppercase tracking-wider">
//                 FORM TYPE
//               </p>
//               <p className="text-sm font-bold text-gray-800">
//                 {getDisplayValue(passedFormType || details?.formType) ||
//                   "Standard"}
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Action Buttons Row */}
//       <div className="flex flex-wrap gap-4 items-center mb-6">
//         <button
//           onClick={() => setOpenModal("assign")}
//           className="bg-[#06513D] text-white px-8 py-2.5 rounded-lg font-bold text-xs hover:bg-[#054031] transition-all active:scale-95"
//         >
//           Assign Form
//         </button>
//         {/* {allottedByRole !== "L1" && (
//           <button
//             onClick={async () => {
//               if (isEmployeeRoute) {
//                 setOpenModal("authorize");
//                 return;
//               }
//               if (orgModeLocked) {
//                 setOpenModal("authorize");
//                 return;
//               }
//               const hideLoading = message.loading("Checking employee assignments...", 0);
//               try {
//                 const response = await getApi({
//                   apiUrl: API_URLS.CHECK_EMPLOYEE_ASSIGNMENTS,
//                 });

//                 if (response?.data?.allAssigned) {
//                   setOpenModal("authorize");
//                 } else {
//                   message.warning(
//                     "Some employees are not assigned to a location or department. Please complete all assignments first."
//                   );
//                 }
//               } catch (error) {
//                 console.error("Assignment check failed:", error);
//                 message.error("Failed to verify employee assignments.");
//               } finally {
//                 hideLoading();
//               }
//             }}
//             className="bg-white text-[#06513D] border border-[#06513D] px-6 py-2.5 rounded-lg font-bold text-xs flex items-center gap-2 hover:bg-[#06513D]/5 transition-all active:scale-95"
//           >
//             <GoShieldCheck className="text-lg" /> Authorize to Manage
//           </button>
//         )} */}

//         {allottedByRole !== "L1" && (
//           <button
//             onClick={async () => {
//               if (isEmployeeRoute) {
//                 setOpenModal("authorize");
//                 return;
//               }
//               const isLicenseZero =
//                 projectDetails?.license?.local_supervisor?.unused === 0;

//               if (isLicenseZero) {
//                 setPopupConfig({
//                   type: "warning",
//                   title: "License Limit Reached",
//                   message: "No Local Supervisor License Available",
//                 });
//                 return;
//               }

//               if (!orgModeLocked) {
//                 setPopupConfig({
//                   type: "warning",
//                   title: "Organization Setup Incomplete",
//                   message:
//                     "Your Organization Structure has not been set up. Please setup that first",
//                   confirmText: "Setup Organization Structure",
//                 });
//                 return;
//               }

//               const hideLoading = message.loading(
//                 "Checking employee assignments...",
//                 0,
//               );
//               try {
//                 const response = await getApi({
//                   apiUrl: API_URLS.CHECK_EMPLOYEE_ASSIGNMENTS,
//                 });

//                 if (response?.data?.allAssigned) {
//                   setOpenModal("authorize");
//                 } else {
//                   setMappingStats({
//                     total: response?.data?.totalEmployees || 0,
//                     mapped: response?.data?.assignedCount || 0,
//                   });
//                   setShowMappingWarning(true);
//                 }
//               } catch (error) {
//                 console.error("Assignment check failed:", error);
//                 message.error("Failed to verify employee assignments.");
//               } finally {
//                 hideLoading();
//               }
//             }}
//             className="bg-white text-[#06513D] border border-[#06513D] px-6 py-2.5 rounded-lg font-bold text-xs flex items-center gap-2 hover:bg-[#06513D]/5 transition-all active:scale-95"
//           >
//             <GoShieldCheck className="text-lg" /> Authorize to Manage
//           </button>
//         )}
//         <button
//           onClick={() =>
//             navigate(
//               `/organization/projects/standard-forms/hierarchy/${formId}`,
//             )
//           }
//           className="bg-[#E6F4EA] text-[#06513D] border border-[#06513D]/20 px-6 py-2.5 rounded-lg font-bold text-xs flex items-center gap-2 hover:bg-[#D7EADD] transition-all"
//         >
//           <MdOutlineAccountTree className="text-lg" /> View Hierarchy
//         </button>
//       </div>

//       {/* Tabs System */}
//       <div className="bg-white border border-[#38A28D] rounded-2xl overflow-hidden shadow-sm">
//         <div className="flex border-b border-gray-100 px-6 pt-2">
//           {["Form Structure", "Form Assignments", "Progress & Analytics"].map(
//             (tab) => (
//               <button
//                 key={tab}
//                 onClick={() => setActiveTab(tab)}
//                 className={`px-8 py-4 text-base font-bold transition-all relative ${
//                   activeTab === tab
//                     ? "text-[#06513D]"
//                     : "text-gray-400 hover:text-gray-600"
//                 }`}
//               >
//                 {tab}
//                 {activeTab === tab && (
//                   <div className="absolute bottom-[-1px] left-0 w-full h-[3px] bg-[#06513D] rounded-t-full"></div>
//                 )}
//               </button>
//             ),
//           )}
//         </div>

//         {/* Tab Content */}
//         <div className="">
//           {activeTab === "Form Structure" && (
//             <div className="p-4">
//               <StandardFormAction
//                 standalone={false}
//                 formAllotmentId={formAllotmentId}
//                 userId={getDisplayValue._id}
//                 templateId={templateId}
//                 hideBackButton={isStandardViewRoute}
//                 formType={
//                   getDisplayValue(passedFormType || details?.formType) ||
//                   "Standard"
//                 }
//               />
//             </div>
//           )}
//           {activeTab === "Form Assignments" && (
//             <div className="p-0">
//               {reduxLoading ? (
//                 <div className="flex justify-center items-center py-20">
//                   <Spin size="large" />
//                 </div>
//               ) : (
//                 <Table
//                   dataSource={tableData}
//                   rowKey={(record) => record.key || record._id}
//                   columns={columns.map((col) => ({
//                     ...col,
//                     title: (
//                       <span className="text-xs font-bold text-gray-800 uppercase tracking-tight">
//                         {col.title}
//                       </span>
//                     ),
//                   }))}
//                   pagination={false}
//                   className="custom-dashboard-table"
//                 />
//               )}

//               {/* Pagination Footer */}
//               <div className="flex justify-between items-center px-6 py-4 border-t border-gray-100 bg-[#F9FBFC]/30">
//                 {/* Page size selector */}
//                 <div className="flex items-center gap-3">
//                   <span className="text-xs text-gray-500 font-medium tracking-tight">
//                     Showing
//                   </span>
//                   <select
//                     value={pageLimit}
//                     onChange={(e) => {
//                       const newLimit = Number(e.target.value);
//                       setPageLimit(newLimit);
//                       setCurrentPage(1);
//                       fetchAssignments(1, newLimit);
//                     }}
//                     className="border border-[#06513D]/20 rounded-lg px-3 py-1 text-xs font-bold text-[#06513D] outline-none bg-white"
//                   >
//                     <option value={10}>10</option>
//                     <option value={20}>20</option>
//                     <option value={50}>50</option>
//                   </select>
//                 </div>

//                 {/* Record count info */}
//                 <div className="text-xs text-gray-400 font-medium tracking-tight">
//                   Showing{" "}
//                   {assignmentsTotal === 0
//                     ? 0
//                     : (currentPage - 1) * pageLimit + 1}{" "}
//                   to {Math.min(currentPage * pageLimit, assignmentsTotal)} out
//                   of {assignmentsTotal} records
//                 </div>

//                 {/* Page buttons */}
//                 <div className="flex items-center gap-1">
//                   {/* Prev */}
//                   <button
//                     disabled={currentPage === 1}
//                     onClick={() => {
//                       const newPage = currentPage - 1;
//                       setCurrentPage(newPage);
//                       fetchAssignments(newPage, pageLimit);
//                     }}
//                     className="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 text-gray-400 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed"
//                   >
//                     <svg
//                       className="w-4 h-4"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M15 19l-7-7 7-7"
//                       />
//                     </svg>
//                   </button>

//                   {/* Page number buttons */}
//                   {(() => {
//                     const totalPages = Math.ceil(assignmentsTotal / pageLimit);
//                     const pages = [];
//                     let start = Math.max(1, currentPage - 1);
//                     let end = Math.min(totalPages, start + 3);
//                     if (end - start < 3) start = Math.max(1, end - 3);

//                     for (let i = start; i <= end; i++) {
//                       pages.push(
//                         <button
//                           key={i}
//                           onClick={() => {
//                             setCurrentPage(i);
//                             fetchAssignments(i, pageLimit);
//                           }}
//                           className={`w-8 h-8 flex items-center justify-center rounded-lg border text-xs font-medium transition-all
//                   ${
//                     currentPage === i
//                       ? "border-[#06513D] bg-white text-[#06513D] font-bold shadow-sm"
//                       : "border-transparent text-gray-500 hover:bg-gray-50"
//                   }`}
//                         >
//                           {i}
//                         </button>,
//                       );
//                     }
//                     return pages;
//                   })()}

//                   {/* Next */}
//                   <button
//                     disabled={
//                       currentPage >= Math.ceil(assignmentsTotal / pageLimit)
//                     }
//                     onClick={() => {
//                       const newPage = currentPage + 1;
//                       setCurrentPage(newPage);
//                       fetchAssignments(newPage, pageLimit);
//                     }}
//                     className="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 text-gray-400 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed"
//                   >
//                     <svg
//                       className="w-4 h-4"
//                       fill="none"
//                       stroke="currentColor"
//                       viewBox="0 0 24 24"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth="2"
//                         d="M9 5l7 7-7 7"
//                       />
//                     </svg>
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}

//           {activeTab === "Progress & Analytics" && (
//             <div className="p-6">
//               <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
//                 <div className="bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
//                   <div className="text-2xl font-black text-[#06513D]">
//                     {progressStats.totalAssigned}
//                   </div>
//                   <div className="text-xs text-gray-400 font-bold uppercase tracking-wider mt-1">
//                     Total Assigned Users
//                   </div>
//                 </div>

//                 <div className="bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
//                   <div className="text-2xl font-black text-[#06513D]">
//                     {progressStats.completedCount}%
//                   </div>
//                   <div className="text-[10px] text-gray-400 font-bold uppercase tracking-wider mt-1">
//                     Completed
//                   </div>
//                 </div>

//                 <div className="bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
//                   <div className="text-2xl font-black text-[#06513D]">
//                     {progressStats.inProgressCount}%
//                   </div>
//                   <div className="text-[10px] text-gray-400 font-bold uppercase tracking-wider mt-1">
//                     In Progress
//                   </div>
//                 </div>

//                 <div className="bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
//                   <div className="text-2xl font-black text-[#06513D]">
//                     {progressStats.pendingCount}%
//                   </div>
//                   <div className="text-[10px] text-gray-400 font-bold uppercase tracking-wider mt-1">
//                     Not Started
//                   </div>
//                 </div>
//               </div>

//               <div className="mt-6 bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
//                 <div className="flex items-center justify-between mb-3">
//                   <div className="text-sm font-bold text-gray-800">
//                     Overall Progress
//                   </div>
//                   <div className="text-xs text-gray-400 font-bold">
//                     {progressStats.completedCount} of{" "}
//                     {progressStats.totalAssigned} users completed
//                   </div>
//                 </div>
//                 <div className="w-full h-3 rounded-full bg-gray-200 overflow-hidden flex">
//                   <div
//                     className="h-full bg-[#06513D]"
//                     style={{ width: `${progressStats.completedPercent}%` }}
//                   />
//                   <div
//                     className="h-full bg-[#FBBF24]"
//                     style={{ width: `${progressStats.inProgressPercent}%` }}
//                   />
//                   <div
//                     className="h-full bg-[#CBD5E1]"
//                     style={{ width: `${progressStats.pendingPercent}%` }}
//                   />
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//       {/* Modals */}
//       <Modal
//         open={openModal === "authorize"}
//         onCancel={() => setOpenModal(null)}
//         footer={null}
//         width={1400}
//         centered
//         destroyOnClose={true}
//         className="authorize-modal-custom"
//         bodyStyle={{ padding: "0", borderRadius: "24px" }}
//         maskStyle={{
//           backdropFilter: "blur(4px)",
//           backgroundColor: "rgba(0,0,0,0.4)",
//         }}
//         closeIcon={
//           <div className="bg-white/80 hover:bg-red-50 hover:text-red-500 p-2 rounded-full shadow-sm transition-all absolute right-4 top-4 z-50">
//             <svg
//               className="w-4 h-4"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="2"
//                 d="M6 18L18 6M6 6l12 12"
//               />
//             </svg>
//           </div>
//         }
//       >
//         <div className="max-h-[90vh] overflow-y-auto custom-scrollbar p-10 bg-gray-50/50">
//           {/* <h2 className="text-2xl font-black text-[#06513D] mb-8 tracking-tight uppercase">
//             {shouldUseLs2 ? "Authorize to Manage (LS2)" : "Authorize to Manage"}
//           </h2> */}
//           {shouldUseLs2 ? (
//             <AuthorizeToManageLS2
//               formId={passedFormId || formId}
//               onClose={() => setOpenModal(null)}
//               projectId={projectId}
//               locationId={locationId}
//               departmentId={departmentId}
//               formAllotmentId={resolvedFormAllotmentId}
//               formType={details?.formType?.toLowerCase() || "standard"}
//             />
//           ) : (
//             <AuthorizeToManage
//               standalone={false}
//               onClose={() => setOpenModal(null)}
//               projectId={projectId}
//               formType={details?.formType?.toLowerCase() || "standard"}
//             />
//           )}
//         </div>
//       </Modal>

//       <Modal
//         open={openModal === "assign"}
//         onCancel={() => setOpenModal(null)}
//         footer={null}
//         width={1200}
//         centered
//         destroyOnClose={true}
//         className="view-standard-form-modal"
//         bodyStyle={{ padding: "0", borderRadius: "24px" }}
//         maskStyle={{
//           backdropFilter: "blur(4px)",
//           backgroundColor: "rgba(0,0,0,0.4)",
//         }}
//         closeIcon={
//           <div className="bg-white/80 hover:bg-red-50 hover:text-red-500 p-2 rounded-full shadow-sm transition-all absolute right-4 top-4 z-50">
//             <svg
//               className="w-4 h-4"
//               fill="none"
//               stroke="currentColor"
//               viewBox="0 0 24 24"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 strokeWidth="2"
//                 d="M6 18L18 6M6 6l12 12"
//               />
//             </svg>
//           </div>
//         }
//       >
//         {/* <div style={scrollableContainer} ref={scrollableContainerRef}>
//           {loading ? (
//             <div className="flex flex-col gap-4 p-4">
//               <Skeleton.Button block active />
//               <Skeleton.Button block active />
//               <Skeleton.Button block active />
//               <Skeleton.Button block active />
//             </div>
//           ) : selectedSubsection ? (
//             <div className="mx-20 shadow-[0_0_16px_0_#3BA2B91F]">
//               {questions.length > 0 ? (
//                 <QuestionUtils
//                   questions={questions}
//                   expandAll={expandAll}
//                   answers={answers}
//                   setAnswers={setAnswers}
//                   onPrevious={handlePrevious}
//                   onNext={handleNext}
//                   canGoPrevious={currentSubsectionIndex > 0}
//                   canGoNext={currentSubsectionIndex < subsections.length - 1}
//                 />
//               ) : (
//                 <p className="text-gray-500 text-center p-8">
//                   No questions available for this subsection.
//                 </p>
//               )}
//             </div>
//           ) : (
//             <p className="text-gray-500 text-center p-8">
//               Please select a subsection to view questions.
//             </p>
//           )}

//           {showGoTop && questions.length > 0 && (
//             <Button
//               type="primary"
//               shape="circle"
//               icon={<ArrowUpOutlined />}
//               size="large"
//               onClick={scrollToTop}
//               style={{
//                 position: "absolute",
//                 bottom: "30px",
//                 right: "60px",
//                 background: "#06513D",
//                 zIndex: 1000,
//                 boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
//               }}
//             />
//           )}
//         </div> */}
//         <div className="max-h-[85vh] overflow-y-auto custom-scrollbar p-10 bg-gray-50/50">
//           {/* <div className="mb-8">
//                         <h2 className="text-2xl font-black text-gray-800 tracking-tight">Assign Form to Fill</h2>

//                     </div> */}
//           <AssignFormPage
//             standalone={false}
//             onClose={() => setOpenModal(null)}
//             formId={passedFormId || (isEmployeeRoute ? null : formId)}
//             projectId={projectId}
//             formName={getDisplayValue(formName || formTitle)}
//             roleType={roleType}
//             locationId={locationId || locationIdRaw}
//             departmentId={departmentId || departmentIdRaw}
//             formAllotmentId={resolvedFormAllotmentId}
//             formType={passedFormType}
//             allotmentType={passedAllotmentType}
//             isEmployeeRoute={isEmployeeRoute}
//           />
//           {/* <div className="flex justify-center mt-8">
//                         <button
//                             onClick={() => setOpenModal(null)}
//                             className="bg-white border border-gray-200 text-gray-600 px-12 py-2.5 rounded-xl font-bold hover:bg-gray-100 transition-all font-[Calibri]"
//                         >
//                             Close Overlay
//                         </button>
//                     </div> */}
//         </div>
//       </Modal>

//       {/* Centralized Popup Notification */}
//       {popupConfig && (
//         <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fadeIn">
//           <PopupCard
//             type={popupConfig.type}
//             title={popupConfig.title}
//             message={popupConfig.message}
//             onConfirm={() => setPopupConfig(null)}
//             confirmText={popupConfig.confirmText || "OK"}
//           />
//         </div>
//       )}
//       {/* Place this just before the closing </div> of the component, alongside other popups */}
//       {showMappingWarning && (
//         <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 animate-fadeIn">
//           <div className="w-full max-w-[500px] mx-4 rounded-[20px] overflow-hidden bg-white border border-gray-100 shadow-2xl">
//             {/* Amber Header */}
//             <div className="bg-[#FAEEDA] px-7 py-6 flex items-start gap-4">
//               <div className="flex-shrink-0 w-11 h-11 rounded-full bg-[#EF9F27] flex items-center justify-center">
//                 <svg
//                   width="22"
//                   height="22"
//                   fill="none"
//                   stroke="#FAEEDA"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   viewBox="0 0 24 24"
//                 >
//                   <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
//                   <line x1="12" y1="9" x2="12" y2="13" />
//                   <line x1="12" y1="17" x2="12.01" y2="17" />
//                 </svg>
//               </div>
//               <div className="flex-1">
//                 <p className="text-base font-semibold text-[#633806] mb-1">
//                   User mapping incomplete
//                 </p>
//                 <p className="text-[13px] text-[#854F0B] leading-relaxed">
//                   Some users are not yet assigned to a location or department.
//                 </p>
//               </div>
//             </div>

//             {/* Body */}
//             <div className="px-7 pt-6 pb-2">
//               <p className="text-[13px] text-gray-500 leading-relaxed mb-5">
//                 Your organization structure is set up, but not all users are
//                 mapped to a location and department.
//               </p>

//               {/* Stat Cards */}
//               <div className="grid grid-cols-2 gap-3 mb-5">
//                 <div className="bg-gray-50 border-l-[3px] border-gray-400 pl-4 py-3">
//                   <p className="text-[22px] font-medium text-gray-900 leading-none mb-1">
//                     {mappingStats.total.toLocaleString()}
//                   </p>
//                   <p className="text-[11px] uppercase tracking-wider text-gray-400">
//                     Total users
//                   </p>
//                 </div>
//                 <div className="bg-[#FAEEDA] border-l-[3px] border-[#EF9F27] pl-4 py-3">
//                   <p className="text-[22px] font-medium text-[#633806] leading-none mb-1">
//                     {mappingStats.mapped.toLocaleString()}
//                   </p>
//                   <p className="text-[11px] uppercase tracking-wider text-[#854F0B]">
//                     Mapped users
//                   </p>
//                 </div>
//               </div>

//               {/* Progress Bar */}
//               <div className="bg-gray-50 rounded-lg px-4 py-3 mb-5">
//                 <div className="flex items-center justify-between mb-2">
//                   <span className="text-[12px] text-gray-400">
//                     Mapping progress
//                   </span>
//                   <span className="text-[12px] font-medium text-[#633806]">
//                     {mappingStats.total > 0
//                       ? Math.round(
//                           (mappingStats.mapped / mappingStats.total) * 100,
//                         )
//                       : 0}
//                     %
//                   </span>
//                 </div>
//                 <div className="h-[6px] bg-gray-200 rounded-full overflow-hidden">
//                   <div
//                     className="h-full bg-[#EF9F27] rounded-full transition-all"
//                     style={{
//                       width: `${
//                         mappingStats.total > 0
//                           ? Math.round(
//                               (mappingStats.mapped / mappingStats.total) * 100,
//                             )
//                           : 0
//                       }%`,
//                     }}
//                   />
//                 </div>
//               </div>

//               {/* Info Note */}
//               <div className="flex items-start gap-3 bg-gray-50 rounded-lg px-4 py-3 mb-6">
//                 <svg
//                   width="15"
//                   height="15"
//                   fill="none"
//                   stroke="#9CA3AF"
//                   strokeWidth="1.5"
//                   viewBox="0 0 24 24"
//                   className="flex-shrink-0 mt-[2px]"
//                 >
//                   <circle cx="12" cy="12" r="10" />
//                   <line x1="12" y1="8" x2="12" y2="12" />
//                   <line x1="12" y1="16" x2="12.01" y2="16" />
//                 </svg>
//                 <p className="text-[12px] text-gray-400 leading-relaxed">
//                   Only mapped users will be available when authorizing{" "}
//                   <span className="text-gray-700 font-medium">
//                     Local Supervisor – Location/Department
//                   </span>{" "}
//                   roles. Complete user mapping for full visibility.
//                 </p>
//               </div>
//             </div>

//             {/* Footer Buttons */}
//             <div className="flex items-center justify-end gap-3 px-4 py-5 border-t border-gray-100">
//               <button
//                 onClick={() => setShowMappingWarning(false)}
//                 className="px-4 py-2 text-[13px] text-gray-400 border border-gray-200 rounded-lg hover:bg-gray-50 transition-all"
//               >
//                 Cancel
//               </button>
//               <button
//                 onClick={() => {
//                   setShowMappingWarning(false);
//                   navigate("/organization/user-management"); // 👈 update path
//                 }}
//                 className="px-4 py-2 text-[13px] text-[#06513D] border border-[#06513D]/40 rounded-lg hover:bg-[#06513D]/5 transition-all flex items-center gap-2"
//               >
//                 <svg
//                   width="13"
//                   height="13"
//                   fill="none"
//                   stroke="#06513D"
//                   strokeWidth="1.5"
//                   viewBox="0 0 24 24"
//                 >
//                   <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
//                   <polyline points="15 3 21 3 21 9" />
//                   <line x1="10" y1="14" x2="21" y2="3" />
//                 </svg>
//                 Go to user mapping
//               </button>
//               <button
//                 onClick={() => {
//                   setShowMappingWarning(false);
//                   setOpenModal("authorize");
//                 }}
//                 className="px-5 py-2 text-[13px] font-semibold text-white bg-[#06513D] rounded-lg hover:bg-[#054031] transition-all active:scale-95"
//               >
//                 Proceed
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {/* Local Styles */}
//       <style
//         dangerouslySetInnerHTML={{
//           __html: `
//                     @keyframes fadeIn { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
//                     .animate-fadeIn { animation: fadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

//                     .custom-dashboard-table .ant-table {
//                         background: transparent !important;
//                     }
//                     .custom-dashboard-table .ant-table-thead > tr > th {
//                         background-color: transparent !important;
//                         color: #B5B5C3 !important;
//                         font-size: 11px !important;
//                         font-weight: 800 !important;
//                         letter-spacing: 0.08em !important;
//                         text-transform: uppercase !important;
//                         border-bottom: 2px solid #F8F9FB !important;
//                         padding: 24px !important;
//                     }
//                     .custom-dashboard-table .ant-table-tbody > tr > td {
//                         padding: 20px 24px !important;
//                         border-bottom: 1px solid #F8F9FB !important;
//                         font-size: 14px !important;
//                         transition: all 0.2s ease;
//                     }
//                     .custom-dashboard-table .ant-table-tbody > tr:hover > td {
//                         background-color: #F9FBFC !important;
//                     }
//                     .custom-scrollbar::-webkit-scrollbar { width: 4px; }
//                     .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
//                     .custom-scrollbar::-webkit-scrollbar-thumb { background: #CBD5E1; border-radius: 10px; }

//                     /* Modal Ant Design Overrides */
//                     .ant-modal-content {
//                         border-radius: 24px !important;
//                         box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15) !important;
//                     }
//                 `,
//         }}
//       />
//     </div>
//   );
// };

// export default ViewStandardForm;
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import {
  useNavigate,
  useParams,
  useLocation,
  useMatch,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import {
  Spin,
  Skeleton,
  message,
  Button,
  Table,
  Tag,
  Modal,
  Dropdown,
  DatePicker,
} from "antd";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { HiOutlineArrowRight } from "react-icons/hi2";
import { FiUsers, FiDownload, FiBarChart2 } from "react-icons/fi";
import { MdGppGood, MdOutlineAccountTree } from "react-icons/md";
import { GoShieldCheck } from "react-icons/go";
import {
  fetchFormAssignments,
  fetchFormDetails,
  clearStatus,
  resetViewFormState,
  fetchProjectById,
} from "../../../../redux/ViewForm/viewFormSlice";
import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
import { QuestionForm } from "./questionForm";
import AuthorizeToManage from "../Projects/ProjectPage/AuthorizeToManage";
import AuthorizeToManageLS2 from "../Projects/ProjectPage/AuthorizeToManageLS2";
import AssignFormDetail from "./AssignFormDetail";
import AssignFormPage from "../Projects/ProjectPage/AssignFormPage";
import QuestionUtils from "./components/QuestionUtils";
import StandardFormAction from "./StandardFormAction";
import {
  ArrowUpOutlined,
  SaveOutlined,
  EyeOutlined,
  MoreOutlined,
  PauseCircleOutlined,
  PlayCircleOutlined,
  UserSwitchOutlined,
  DeleteOutlined,
  CheckOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { ReactComponent as Back } from "../../../../assets/svgs/back-button.svg";
import { getApi, patchApi } from "../../../../api/api_instance";
import PopupCard from "../../../Auth/PopupCard";

import { SearchBar } from "../../../../components/Elements/Search/SearchBar";

import { API_URLS } from "../../../../api/apiUrls";

const LocalPopupCard = ({
  type,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = "Confirm",
  cancelText = "Cancel",
  widthClass = "sm:w-[320px]",
  confirmBtnClass,
  cancelBtnClass,
}) => {
  const typeStyles = {
    success: {
      headerBg: "bg-[#06513D]",
      icon: <CheckOutlined style={{ fontSize: 32, color: "#ffffff" }} />,
      iconBg: "bg-[#06513D]",
      textColor: "text-[#06513D]",
    },
    warning: {
      headerBg: "bg-[#FFC107]",
      icon: <ExclamationCircleOutlined style={{ fontSize: 32 }} />,
      iconBg: "bg-[#FFC107]",
      textColor: "text-[#06513D]",
    },
    error: {
      headerBg: "bg-[#D32F2F]",
      icon: <CloseCircleOutlined style={{ fontSize: 32, color: "#ffffff" }} />,
      iconBg: "bg-[#D32F2F]",
      textColor: "text-[#06513D]",
    },
  };

  const { headerBg, icon, iconBg, textColor } =
    typeStyles[type] || typeStyles.error;

  const resolvedConfirmBtnClass =
    confirmBtnClass || "w-32 px-2 py-1 rounded bg-[#06513D] text-white";
  const resolvedCancelBtnClass =
    cancelBtnClass ||
    "w-32 px-2 py-1 rounded border border-[#06513D] text-[#06513D]";

  return (
    <div
      className={`w-full ${widthClass} rounded-md shadow-md overflow-hidden bg-white text-center font-sans`}
    >
      <div className={`py-2 ${headerBg} text-white font-semibold`}>{title}</div>
      <div className=" p-6 flex flex-col items-center gap-3">
        <div
          className={`w-12 h-12 rounded-full flex items-center justify-center ${iconBg}`}
        >
          {icon}
        </div>
        <p className={`text-base font-semibold  ${textColor}`}>{message}</p>
        {(onConfirm || onCancel) && (
          <div className="flex gap-4 ">
            {onCancel && (
              <button onClick={onCancel} className={resolvedCancelBtnClass}>
                {cancelText}
              </button>
            )}
            {onConfirm && (
              <button onClick={onConfirm} className={resolvedConfirmBtnClass}>
                {confirmText}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const ViewStandardForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { formId } = useParams();
  const location = useLocation();
  const isStandardViewRoute = Boolean(
    useMatch("/organization/projects/standard-forms/view/:formId"),
  );

  const isEmployeeRoute = location.pathname.startsWith("/employee");
  const getId = (val) => (typeof val === "object" ? val?._id : val);
  const getDisplayValue = (val) => {
    if (!val) return "";
    if (typeof val === "string" || typeof val === "number") return String(val);
    if (typeof val === "object") {
      return (
        val.name ||
        val.projectName ||
        val.formName ||
        val.title ||
        val._id ||
        ""
      );
    }
    return "";
  };
  const { formId: allotmentId } = useParams();

  const id = allotmentId || allotmentIdFromState;
  const {
    formName,
    formTitle,
    projectId,
    formId: passedFormId,
    formType: passedFormType,
    allotmentType: passedAllotmentType,
    source,
    manageLevel,
    roleType,
    locationId,
    departmentId,
    locationIdRaw,
    departmentIdRaw,
    formAllotmentId,
    allottedByRole,
    progress,
    period,
    frequecy,
    periods,
    userId,
    templateId,
    id: allotmentIdFromState,
    formIdRaw,
  } = location.state || {};

  const resolvedFormAllotmentId =
    formAllotmentId || (isEmployeeRoute ? formId : "");

  // If manageLevel is not passed but roleType is, use roleType as the manageLevel
  // const currentManageLevel = manageLevel !== undefined ? manageLevel : roleType;
  console.log(formName, "formasjdkadsk");

  // Redux State
  const authUser = useSelector((state) => state.auth.user);
  const orgModeLocked = authUser?.orgModeLocked || false;
  console.log("orgModeLocked in ViewStandardForm:", orgModeLocked);

  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);
  const [subsections, setSubsections] = useState([]);
  const [selectedSubsection, setSelectedSubsection] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({});

  const [currentSubsectionIndex, setCurrentSubsectionIndex] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const pageSize = 100;

  const [expandAll, setExpandAll] = useState(false);
  const [showGoTop, setShowGoTop] = useState(false);
  {
    /* Add these two states at the top with other states */
  }
  const [showMappingWarning, setShowMappingWarning] = useState(false);
  const [mappingStats, setMappingStats] = useState({ total: 0, mapped: 0 });
  const [currentPage, setCurrentPage] = useState(
    location.state?.currentPage || 1,
  );
  const [pageLimit, setPageLimit] = useState(location.state?.pageLimit || 10);
  const scrollableContainerRef = useRef(null);

  const scrollableContainer = {
    maxHeight: "1000px",
    overflowY: "auto",
    padding: "10px",
    borderRadius: "8px",
  };
  const shouldUseLs2 = location.pathname.startsWith("/employee");
  const {
    assignments,
    assignmentsTotal, // ← add these
    assignmentsLimit,
    assignmentsSkip,
    details,
    projectDetails,
    loading: reduxLoading,
    error: reduxError,
  } = useSelector((state) => state.viewForm);
  const projectdetailslicense =
    projectDetails?.license.local_supervisor?.unused == 0 || {};
  console.log(
    projectdetailslicense,
    "projectDetails in 1111111111111111111111111111111111",
  );

  const currentFormId = formIdRaw || passedFormId || templateId || formId;
  const currentFormConfig = useMemo(() => {
    const standardForms = projectDetails?.standard_form || [];
    return standardForms.find(
      (f) =>
        String(f.id) === String(currentFormId) ||
        String(f._id) === String(currentFormId),
    );
  }, [projectDetails, currentFormId]);

  const allotmentMode = currentFormConfig?.allotment_mode;

  const formatFrequency = useCallback((frequency) => {
    if (!frequency) return "-";

    const frequencyMap = {
      year: "Yearly",
      half_year: "Half Yearly",
      quaterly: "Quarterly",
      monthly: "Monthly",
    };

    const normalizedFrequency = String(frequency).toLowerCase();
    return frequencyMap[normalizedFrequency] || frequency;
  }, []);

  // Local State
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "Form Structure",
  );

  useEffect(() => {
    navigate(location.pathname, {
      replace: true,
      state: {
        ...location.state,
        activeTab,
        currentPage,
        pageLimit,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, currentPage, pageLimit, navigate, location.pathname]);
  const [editingId, setEditingId] = useState(null);
  const [openModal, setOpenModal] = useState(null); // 'authorize' or 'assign'
  const [popupConfig, setPopupConfig] = useState(null); // { type, title, message, confirmText }
  const [hierarchyProgress, setHierarchyProgress] = useState(null);
  const [periodsList, setPeriodsList] = useState([]);
  const [loadingProgress, setLoadingProgress] = useState(false);
  const [subAllotmentMode, setSubAllotmentMode] = useState(
    location.state?.subAllotmentMode || null,
  );
  const activeAllotmentMode = isEmployeeRoute
    ? subAllotmentMode
    : allotmentMode;

  const safeProgress = isEmployeeRoute
    ? progress || {}
    : hierarchyProgress || progress || {};
  const total = safeProgress.totalRecipients || 0;

  const progressStats = {
    totalAssigned: safeProgress.totalRecipients || 0,
    completedPercent:
      safeProgress.overallPercentage !== undefined
        ? safeProgress.overallPercentage
        : 0,
    inProgressPercent:
      safeProgress.totalRecipients > 0
        ? Math.round(
            ((safeProgress.inProgress || 0) / safeProgress.totalRecipients) *
              100,
          )
        : 0,
    pendingPercent:
      safeProgress.totalRecipients > 0
        ? Math.round(
            ((safeProgress.notStarted || 0) / safeProgress.totalRecipients) *
              100,
          )
        : 0,
    completedCount: safeProgress.completed || 0,
    inProgressCount: safeProgress.inProgress || 0,
    pendingCount: safeProgress.notStarted || 0,
  };

  const handleViewAssignment = async (record) => {
    const isEmployee = location.pathname.startsWith("/employee");
    const isFormAssignmentTab = activeTab === "Form Assignments";

    let basePath = isEmployee
      ? "/employee/manage-form/user-details/view"
      : isFormAssignmentTab
        ? "/organization/projects/standard-forms/form-assignment/view"
        : "/organization/user-management/user-details/view";

    // --- Default values from your working snippet ---
    const allotmentIdVal = isEmployeeRoute
      ? formId
      : record._id || record.allotmentId;
    let finalAllotmentId = allotmentIdVal;
    let standardFormAllotmentId = record.standardFormAllotmentIds?.[0];
    let userSubDocId = record._id || record.allotmentId;
    // -----------------------------------------------
    let standardFormAllotmentIdhierarchy =
      record.standardFormAllotmentId || record.standardFormAllotmentIds?.[0];

    const actualTemplateId =
      record.formId?._id ||
      record.templateId ||
      record.template?._id ||
      details?.formId?._id ||
      details?.formId ||
      templateId ||
      passedFormId ||
      formId;

    const resolveId = (val) => (typeof val === "object" ? val?._id : val);
    const employeeIdVal =
      record.employee?._id ||
      record.employee?.id ||
      record.employee_id ||
      record.user?.[0]?.id ||
      record.user?.[0]?._id ||
      record.user?._id ||
      record.userId ||
      record.user_id;

    // Resolve authoritative IDs via API ONLY for Client-side Form Assignments
    // BUT SKIP if we already have a specific standardFormAllotmentId from the record
    if (
      isFormAssignmentTab &&
      employeeIdVal &&
      !isEmployee &&
      !standardFormAllotmentId
    ) {
      try {
        const response = await getApi({
          apiUrl: API_URLS.GET_PROJECTS_BY_USER_ID(employeeIdVal),
        });
        if (response.success && response.data?.[0]) {
          const targetTid = String(
            resolveId(formId) || resolveId(actualTemplateId),
          );
          const targetPid = resolveId(
            record.projectId?._id ||
              record.projectId ||
              record.project?._id ||
              projectId,
          );

          const allotments = response.data[0].formAllotments || [];
          console.log("Matching Debug:", {
            targetTid,
            targetPid,
            allotmentsCount: allotments.length,
          });

          let match = allotments.find((a) => {
            const aTid = String(
              resolveId(a.templateId) || resolveId(a.template),
            );
            const aPid = String(resolveId(a.projectId) || resolveId(a.project));

            // If we have both, match both. Otherwise match Tid.
            if (targetPid && aPid !== "undefined") {
              return aTid === targetTid && aPid === String(targetPid);
            }
            return aTid === targetTid;
          });

          if (match) {
            console.log("Match Found:", match);
            finalAllotmentId = match._id;
            standardFormAllotmentId = match._id;

            // Try different nested ID paths
            userSubDocId =
              match.user?.[0]?._id ||
              match.user?.[0]?.id ||
              match.user?._id ||
              match.user?.id ||
              match._id;
          } else {
            console.warn("No match found for Tid:", targetTid);
          }
        }
      } catch (error) {
        console.error("ViewStandardForm - Error resolving IDs:", error);
      }
    }

    // Use employeeIdVal in the URL for Client-side Form Assignments tab
    const urlId =
      isFormAssignmentTab && employeeIdVal && !isEmployee
        ? employeeIdVal
        : finalAllotmentId;

    navigate(`${basePath}/${urlId}`, {
      state: {
        projectId:
          record.projectId?._id ||
          record.projectId ||
          record.project?._id ||
          projectId,
        templateId: actualTemplateId,
        parentAllotmentId: formId,
        allotmentId: finalAllotmentId,
        standardFormAllotmentId:
          standardFormAllotmentIdhierarchy ||
          standardFormAllotmentId ||
          finalAllotmentId,
        employeeId: employeeIdVal,
        userId: employeeIdVal,
        userSubDocId: userSubDocId,
        formName:
          record.formId?.title ||
          record.template?.title ||
          record.template?.name ||
          formTitle,
        formTitle: record.formId?.title || record.template?.title || formTitle,
        allotmentType: record.allotmentType,
        isFromFormAssignment: isFormAssignmentTab,
      },
    });
  };

  const handleActionMenuClick = async (action, record) => {
    if (action === "view") {
      await handleViewAssignment(record);
      return;
    }

    const employeeIdVal =
      record.employee?._id ||
      record.employee?.id ||
      record.employee_id ||
      record.user?.[0]?.id ||
      record.user?.[0]?._id ||
      record.user?._id ||
      record.userId ||
      record.user_id;
    const formAllotmentId = record.allotmentId || record._id;

    if (!employeeIdVal || !formAllotmentId) {
      message.error("Missing required identifiers for this action.");
      return;
    }

    const triggerStatusUpdate = async (status) => {
      const hideLoading = message.loading(`Updating status to ${status}...`, 0);
      try {
        const apiUrl = isEmployeeRoute
          ? API_URLS.EMP_UPDATE_HIERARCHY_STATUS(formAllotmentId, employeeIdVal)
          : API_URLS.UPDATE_HIERARCHY_STATUS(formAllotmentId, employeeIdVal);

        const response = await patchApi({
          apiUrl,
          data: { status },
        });

        if (response.success) {
          setPopupConfig({
            type: "success",
            title: "Status Updated",
            message: `Status updated to ${status}`,
            confirmText: "OK",
          });
          // Refresh assignments list to show new status
          fetchAssignments(currentPage, pageLimit);
        } else {
          message.error(response.message || "Failed to update status");
        }
      } catch (error) {
        console.error("Status update error:", error);
        message.error("An error occurred while updating status");
      } finally {
        hideLoading();
      }
    };

    if (action === "pause") {
      setPopupConfig({
        type: "warning",
        title: "Pause Form Access",
        message:
          "Are you sure you want to pause access for this user?\nThe user will temporarily lose the ability to view, edit, and submit data for the assigned form & Authorized form. Access can be restored at any time by selecting Resume Access.",
        confirmText: "Pause Access",
        cancelText: "Cancel",
        widthClass: "sm:w-[450px] md:w-[500px]",
        onConfirm: () => {
          setPopupConfig(null);
          triggerStatusUpdate("Access Paused");
        },
        onCancel: () => setPopupConfig(null),
      });
      return;
    }

    if (action === "revoke") {
      setPopupConfig({
        type: "warning",
        title: "Revoke Form Access",
        message:
          "Are you sure you want to revoke access for this user?\nThe user will permanently lose access to the assigned form & Authorized form, and the allocated license will be released. If access is required again in the future, a new assignment must be created.",
        confirmText: "Revoke Access",
        cancelText: "Cancel",
        widthClass: "sm:w-[450px] md:w-[500px]",
        onConfirm: () => {
          setPopupConfig(null);
          triggerStatusUpdate("Access Removed");
        },
        onCancel: () => setPopupConfig(null),
      });
      return;
    }

    if (action === "resume") {
      setPopupConfig({
        type: "warning",
        title: "Resume Form Access",
        message:
          "Are you sure you want to resume access for this user?\nThe user will regain access to the assigned form & Authorized form and will be able to continue viewing, editing, and submitting data from where they previously left off.",
        confirmText: "Resume Access",
        cancelText: "Cancel",
        widthClass: "sm:w-[450px] md:w-[500px]",
        onConfirm: () => {
          setPopupConfig(null);
          triggerStatusUpdate("Assigned");
        },
        onCancel: () => setPopupConfig(null),
      });
      return;
    }

    if (action === "reassign") {
      message.info("Reassign action will be added soon.");
      return;
    }
  };

  // const progressStats = {
  // totalAssigned: progress?.totalRecipients || 0,
  // completedPercent: progress?.overallPercentage || 0,
  // inProgressPercent: progress?.inProgress || 0,
  // pendingPercent: progress?.notStarted || 0,
  // completedCount: progress?.completed || 0,
  // inProgressCount: progress?.inProgress || 0,
  // pendingCount: progress?.notStarted || 0,
  // };

  const fetchedFormIdRef = useRef(null);

  // useEffect(() => {
  //   // ✅ formIdRaw employee ke liye, passedFormId/templateId/formId customer admin ke liye
  //   const resolvedFormId = formIdRaw || passedFormId || templateId || formId;

  //   if (resolvedFormId) {
  //     console.log("Fetching assignments for:", resolvedFormId, "isEmployee:", isEmployeeRoute);
  //     fetchedFormIdRef.current = resolvedFormId;
  //     dispatch(fetchFormAssignments({
  //       formId: resolvedFormId,
  //       isEmployee: isEmployeeRoute,
  //       skip: 0,
  //       limit: 10,
  //     }));
  //   }

  //   if (isStandardViewRoute && projectId) {
  //     dispatch(fetchProjectById(projectId));
  //   }

  //   return () => {
  //     dispatch(resetViewFormState());
  //   };
  // }, [dispatch, formIdRaw, passedFormId, templateId, formId, projectId]);

  // ✅ useEffect ke BAHAR — pehle define karo
  const fetchAssignments = useCallback(
    (page, limit) => {
      const resolvedFormId = formIdRaw || passedFormId || templateId || formId;
      if (!resolvedFormId) return;
      const skip = (page - 1) * limit;
      dispatch(
        fetchFormAssignments({
          formId: resolvedFormId,
          isEmployee: isEmployeeRoute,
          skip,
          limit,
          projectId,
        }),
      );
    },
    [
      dispatch,
      formIdRaw,
      passedFormId,
      templateId,
      formId,
      isEmployeeRoute,
      projectId,
    ],
  );

  const fetchHierarchyProgress = useCallback(async () => {
    if (isEmployeeRoute) return;

    const resolvedFormId = formIdRaw || passedFormId || templateId || formId;
    const resolvedProjectId =
      projectId || projectDetails?._id || projectDetails?.id;
    if (!resolvedFormId) return;

    setLoadingProgress(true);
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_FORM_HIERARCHY_PROGRESS(
          resolvedFormId,
          resolvedProjectId,
        ),
      });
      if (response.success && response.data) {
        setHierarchyProgress(response.data.progress || null);
        setPeriodsList(response.data.periods || []);
      }
    } catch (error) {
      console.error("Error fetching hierarchy progress:", error);
    } finally {
      setLoadingProgress(false);
    }
  }, [
    isEmployeeRoute,
    formIdRaw,
    passedFormId,
    templateId,
    formId,
    projectId,
    projectDetails,
  ]);

  const fetchParentAllotmentDetails = useCallback(async () => {
    if (!isEmployeeRoute) return;
    const resolvedAllotmentId = formId;
    if (!resolvedAllotmentId) return;

    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_MANAGED_FORMS,
      });
      if (response.success && response.data) {
        const currentAllotment = response.data.find(
          (item) => String(item._id) === String(resolvedAllotmentId),
        );
        if (currentAllotment) {
          setSubAllotmentMode(currentAllotment.sub_allotment_mode || null);
        }
      }
    } catch (error) {
      console.error("Error fetching parent allotment details:", error);
    }
  }, [isEmployeeRoute, formId]);

  const refreshProjectDetails = useCallback(() => {
    if (!isEmployeeRoute) {
      if (projectId) {
        dispatch(fetchProjectById(projectId));
      }
    } else {
      fetchParentAllotmentDetails();
    }
    fetchAssignments(currentPage, pageLimit);
  }, [
    projectId,
    currentPage,
    pageLimit,
    fetchAssignments,
    dispatch,
    isEmployeeRoute,
    fetchParentAllotmentDetails,
  ]);

  // ✅ useEffect mein sirf call karo
  useEffect(() => {
    fetchAssignments(currentPage, pageLimit);

    if (!isEmployeeRoute && isStandardViewRoute && projectId) {
      dispatch(fetchProjectById(projectId));
    }

    if (isEmployeeRoute) {
      fetchParentAllotmentDetails();
    }

    return () => {
      dispatch(resetViewFormState());
    };
  }, [
    fetchAssignments,
    projectId,
    isEmployeeRoute,
    isStandardViewRoute,
    fetchParentAllotmentDetails,
  ]); // fetchAssignments dependency mein dena

  useEffect(() => {
    if (activeTab === "Progress & Analytics" && !isEmployeeRoute) {
      fetchHierarchyProgress();
    }
  }, [activeTab, fetchHierarchyProgress, isEmployeeRoute]);

  useEffect(() => {
    const handleContainerScroll = () => {
      if (scrollableContainerRef.current) {
        const scrollTop = scrollableContainerRef.current.scrollTop;
        setShowGoTop((prev) => prev || scrollTop > 200);
      }
    };

    const containerElement = scrollableContainerRef.current;
    if (containerElement) {
      containerElement.addEventListener("scroll", handleContainerScroll);
      return () =>
        containerElement.removeEventListener("scroll", handleContainerScroll);
    }
  }, [questions, selectedSubsection]);

  const fetchSections = async () => {
    setLoading(true);
    try {
      const response = await getApi(
        {
          apiUrl: API_URLS.GET_GET_STANDARD_FORM_Section(id),
        },
        true,
      );

      if (response.success) {
        if (response.data.sections.length > 0) {
          const firstSection = response.data.sections[0];
          setSections(response.data.sections);
          setSelectedSection(firstSection.sectionId);
          await fetchSubsections(firstSection.sectionId);
        }
      } else {
        console.error("Failed to fetch sections");
      }
    } catch (error) {
      console.error("Error fetching sections", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSubsections = async (sectionId) => {
    setLoading(true);
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_GET_STANDARD_FORM_Subsection(id, sectionId),
      });

      if (response.success) {
        setSubsections(response.data.subsections);
        setSelectedSection(sectionId);

        if (response.data.subsections.length > 0) {
          const firstSubsection = response.data.subsections[0];
          setSelectedSubsection(firstSubsection.subsectionId);
          // Pass the IDs directly instead of relying on state
          await fetchQuestions(sectionId, firstSubsection.subsectionId);
        } else {
          setQuestions([]);
        }
      } else {
        console.error("Failed to fetch subsections");
        setSubsections([]);
        setQuestions([]);
      }
    } catch (error) {
      console.error("Error fetching subsections", error);
      setSubsections([]);
      setQuestions([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchQuestions = async (sectionId, subsectionId) => {
    // Use parameters instead of state
    const section = sectionId || selectedSection;
    const subsection = subsectionId || selectedSubsection;

    console.log("Fetching questions for:", { section, subsection });

    if (!section || !subsection) {
      console.log("Missing section or subsection ID");
      return;
    }

    setLoading(true);
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_GET_STANDARD_FORM_Questions(
          id,
          section,
          subsection,
        ),
      });

      console.log("Questions response:", response);

      if (response.success) {
        let divisions = response.data.divisions || [];
        setQuestions(divisions);
        console.log("Divisions set:", divisions);
      } else {
        setQuestions([]);
      }
    } catch (error) {
      console.error("Error fetching questions", error);
      message.error("Failed to fetch questions");
      setQuestions([]);
    } finally {
      setLoading(false);
    }
  };

  const scrollToTop = () => {
    if (scrollableContainerRef.current) {
      scrollableContainerRef.current.scrollTop = 0;
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
    setShowGoTop(false);
  };

  const handleSubsectionClick = (subsectionId) => {
    const index = subsections.findIndex((s) => s.subsectionId === subsectionId);
    if (index !== -1) {
      setCurrentSubsectionIndex(index);
    }
    setSelectedSubsection(subsectionId);
    fetchQuestions(selectedSection, subsectionId);
  };

  const handlePrevious = () => {
    if (currentSubsectionIndex > 0) {
      const newIndex = currentSubsectionIndex - 1;
      const prevSub = subsections[newIndex];
      setCurrentSubsectionIndex(newIndex);
      setSelectedSubsection(prevSub.subsectionId);
      fetchQuestions(selectedSection, prevSub.subsectionId);
      scrollToTop();
    }
  };

  const handleNext = async () => {
    const isLast = currentSubsectionIndex >= subsections.length - 1;

    if (!isLast) {
      const newIndex = currentSubsectionIndex + 1;
      const nextSub = subsections[newIndex];
      setCurrentSubsectionIndex(newIndex);
      setSelectedSubsection(nextSub.subsectionId);
      fetchQuestions(selectedSection, nextSub.subsectionId);
      scrollToTop();
    } else {
      setPopupConfig({
        type: "success",
        title: "Completed",
        message: "Subsection navigation complete.",
        confirmText: "OK",
      });
    }
  };

  // Error handling with PopupCard
  useEffect(() => {
    if (reduxError) {
      setPopupConfig({
        type: "error",
        title: "Error Occurred",
        message: reduxError,
        confirmText: "Close",
      });
      dispatch(clearStatus());
    }
  }, [reduxError, dispatch]);

  // Use Redux assignments data with mapping for API response keys
  // const tableData = (assignments || []).map((item) => ({
  //   ...item,
  //   key: item.allotmentId || item._id,
  //   type:
  //     item.allotmentType
  //       ? item.allotmentType.charAt(0).toUpperCase() + item.allotmentType.slice(1)
  //       : "N/A",
  //   level: item.sections?.length > 0 ? "Section" : "N/A",
  //   scope:
  //     item.sections?.map((s) => s.charAt(0).toUpperCase() + s.slice(1)).join(", ") ||
  //     "-",
  //   assignedTo: item.employee?.name || "N/A",
  //   assignedBy: item.allottedBy || "Admin",
  //   status: item.status || "Assigned",
  //   endDate: item.expiresAt ? new Date(item.expiresAt).toLocaleDateString() : "-",
  // }));
  const tableData = (assignments || []).map((item) => ({
    ...item,
    key: item.allotmentId || item._id,

    type: item.allotmentType
      ? item.allotmentType.toLowerCase() === "handle"
        ? "Manage"
        : item.allotmentType.charAt(0).toUpperCase() +
          item.allotmentType.slice(1)
      : "N/A",

    // ✅ Use API level directly
    level: item.level || "N/A",

    // ✅ Format sections nicely
    scope: item?.locationId?.name || item?.departmentId?.name || "-",

    assignedTo: item.employee?.name || "N/A",

    // ✅ FIXED (was wrong before)
    assignedBy: item.assignedBy?.name || "Admin",

    status: item.status || "Assigned",

    // ✅ FIXED (use endDate from API)
    endDate: item.endDate ? new Date(item.endDate).toLocaleDateString() : "-",
    rawEndDate: item.endDate || null,
    period: item.period || "N/A",
  }));

  const getStatusColor = (status) => {
    switch (status) {
      case "Active":
        return "#E6F4EA"; // Green
      case "In Progress":
        return "#FEF7E0"; // Yellow
      case "Completed":
        return "#E8F0FE"; // Blue
      case "Paused":
        return "#FCE8E6"; // Red
      case "Revoked":
        return "#F1F3F4"; // Gray
      default:
        return "#F1F3F4";
    }
  };

  const getStatusTextColor = (status) => {
    switch (status) {
      case "Active":
        return "#137333";
      case "In Progress":
        return "#B06000";
      case "Completed":
        return "#1967D2";
      case "Paused":
        return "#C5221F";
      case "Revoked":
        return "#5F6368";
      default:
        return "#5F6368";
    }
  };

  const columns = [
    {
      title: "TYPE",
      dataIndex: "type",
      key: "type",
      align: "center",
      width: 100,
      render: (text) => (
        <span className="block text-center whitespace-normal break-words">
          {text}
        </span>
      ),
    },
    {
      title: "LEVEL",
      dataIndex: "level",
      key: "level",
      align: "center",
      width: 100,
      render: (text) => (
        <span className="block text-center whitespace-normal break-words">
          {text}
        </span>
      ),
    },
    {
      title: "PERIOD",
      dataIndex: "period",
      key: "period",
      align: "center",
      width: 120,
      render: (text) => (
        <span className="block text-center font-medium whitespace-normal break-words">
          {text}
        </span>
      ),
    },
    {
      title: "Location / Department",
      dataIndex: "scope",
      key: "scope",
      align: "center",
      width: 180,
      render: (text) => (
        <span className="block min-w-0 font-medium text-center whitespace-normal break-words">
          {text}
        </span>
      ),
    },
    {
      title: "ASSIGNED BY",
      dataIndex: "assignedBy",
      key: "assignedBy",
      align: "center",
      width: 150,
      render: (text) => (
        <span className="block whitespace-normal text-center break-words">
          {text}
        </span>
      ),
    },
    {
      title: "ASSIGNED TO",
      dataIndex: "assignedTo",
      key: "assignedTo",
      align: "center",
      width: 150,
      render: (text) => (
        <span className="block whitespace-normal text-center break-words">
          {text}
        </span>
      ),
    },

    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
      align: "center",
      width: 120,
      render: (status) => (
        <Tag
          style={{
            backgroundColor: getStatusColor(status),
            color: getStatusTextColor(status),
            border: `1px solid ${getStatusTextColor(status)}30`,
            borderRadius: "8px",
            padding: "2px 16px",
            fontWeight: "700",
            fontSize: "11px",
            maxWidth: "100%",
            minWidth: "90px",
            textAlign: "center",
            whiteSpace: "normal",
          }}
        >
          {status}
        </Tag>
      ),
    },
    {
      title: "END DATE",
      dataIndex: "endDate",
      key: "endDate",
      align: "center",
      width: 150,
      render: (text, record) => {
        const isEditing = editingId === (record.allotmentId || record._id);
        const rawDate = record.rawEndDate ? dayjs(record.rawEndDate) : null;

        if (isEditing) {
          return (
            <DatePicker
              value={rawDate && rawDate.isValid() ? rawDate : null}
              format="DD/MM/YYYY"
              autoFocus
              open
              variant="borderless"
              bordered={false}
              disabledDate={(current) =>
                current && current < dayjs().startOf("day")
              }
              onOpenChange={(open) => {
                if (!open) setEditingId(null);
              }}
              className="w-full text-center custom-edit-datepicker"
              onChange={(date) => {
                setEditingId(null);
                if (!date) return;
                const formattedDate = `${date.format("YYYY-MM-DD")}T00:00:00.000Z`;

                setPopupConfig({
                  type: "warning",
                  title: "Update Form Submission Deadline",
                  message:
                    "Are you sure you want to change the form submission deadline?",
                  confirmText: "Update End Date",
                  cancelText: "Cancel",
                  onConfirm: async () => {
                    setPopupConfig(null);
                    const hideLoading = message.loading(
                      "Updating end date...",
                      0,
                    );
                    try {
                      const resolvedProjectId =
                        getId(record.projectId) ||
                        getId(record.project) ||
                        getId(projectId);
                      const resolvedTemplateId =
                        getId(record.templateId) ||
                        getId(record.template) ||
                        getId(record.formId) ||
                        getId(currentFormId);
                      const resolvedUserId =
                        record.employee?._id ||
                        record.employee?.id ||
                        record.employee_id ||
                        record.user?.[0]?.id ||
                        record.user?.[0]?._id ||
                        record.user?._id ||
                        record.userId ||
                        record.user_id;

                      const apiUrl = isEmployeeRoute
                        ? "/api/emp/hierarchy/update-end-date"
                        : "/api/client/standard-assign-form-allotment/update-end-date";

                      const requestData = isEmployeeRoute
                        ? {
                            projectId: resolvedProjectId,
                            formId: resolvedTemplateId,
                            employeeId: resolvedUserId,
                            endDate: formattedDate,
                          }
                        : {
                            projectId: resolvedProjectId,
                            templateId: resolvedTemplateId,
                            userId: resolvedUserId,
                            endDate: formattedDate,
                          };

                      await patchApi(
                        {
                          apiUrl: apiUrl,
                          data: requestData,
                        },
                        false,
                      );

                      setPopupConfig({
                        type: "success",
                        title: "Success",
                        message: "End date updated successfully",
                        hideConfirm: true,
                      });
                      setTimeout(() => {
                        setPopupConfig(null);
                        fetchAssignments(currentPage, pageLimit);
                      }, 2000);
                    } catch (err) {
                      console.error("Failed to update end date", err);
                      let errorMessage =
                        err.message || "Failed to update end date";
                      if (
                        errorMessage.includes("status code 400") ||
                        errorMessage.includes("Request failed")
                      ) {
                        errorMessage =
                          "End date cannot exceed project end date";
                      }
                      setPopupConfig({
                        type: "error",
                        title: "Error",
                        message: errorMessage,
                        hideConfirm: true,
                      });
                      setTimeout(() => {
                        setPopupConfig(null);
                      }, 3000);
                    } finally {
                      hideLoading();
                    }
                  },
                  onCancel: () => {
                    setPopupConfig(null);
                  },
                });
              }}
            />
          );
        }

        return (
          <span
            onClick={() => setEditingId(record.allotmentId || record._id)}
            className="cursor-pointer hover:text-[#06513D] hover:underline font-medium text-center block w-full py-1 rounded"
          >
            {text || "-"}
          </span>
        );
      },
    },
    {
      title: "ACTIONS",
      key: "actions",
      align: "center",
      render: (text, record) => (
        <Dropdown
          trigger={["click"]}
          placement="bottomRight"
          menu={{
            items: [
              {
                key: "view",
                label: "View",
                icon: <EyeOutlined />,
              },
              ...(record.status === "Assigned"
                ? [
                    {
                      key: "pause",
                      label: "Pause",
                      icon: <PauseCircleOutlined />,
                    },
                  ]
                : []),
              ...(record.status === "Access Paused"
                ? [
                    {
                      key: "resume",
                      label: "Resume",
                      icon: <PlayCircleOutlined />,
                    },
                  ]
                : []),
              // {
              //   key: "reassign",
              //   label: "Reassign",
              //   icon: <UserSwitchOutlined />,
              // },
              ...(record.status != "Access Removed" &&
              record.status != "Form Filling Completed"
                ? [
                    {
                      key: "revoke",
                      label: "Revoke",
                      icon: <DeleteOutlined />,
                      danger: true,
                    },
                  ]
                : []),
            ],
            onClick: ({ key }) => handleActionMenuClick(key, record),
          }}
        >
          <button
            type="button"
            className="inline-flex flex-shrink-0 items-center justify-center w-9 h-9 rounded-full border border-[#D7E6E1] text-[#06513D] hover:bg-[#EAF4F1] transition"
            aria-label="Open actions menu"
          >
            <MoreOutlined style={{ fontSize: "18px" }} />
          </button>
        </Dropdown>
      ),
    },
  ];

  return (
    <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      {/* Header Breadcrumb */}

      <div className="flex flex-wrap justify-end text-[10px] h-5 font-medium gap-1 sm:gap-2 text-gray-400">
        <p>Home</p>
        <span>/</span>
        <p>Projects</p>
        <span>/</span>
        <p>Project Details Page</p>
        <span>/</span>
        <TextStyles style={{ color: "#06513D", fontSize: "10px" }}>
          Form Details Page
        </TextStyles>
      </div>
      <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
        <IoArrowBackCircleOutline
          onClick={() => {
            if (location.state?.source === "standard-form-list") {
              navigate("/organization/projects/projectPage", {
                state: {
                  ...location.state.projectPageLocationState,
                  standardFormPage: location.state.standardFormPage,
                  standardFormSearch: location.state.standardFormSearch,
                },
              });
            } else {
              navigate(-1);
            }
          }}
          className="w-8 h-8 text-[#06513D] hover:scale-105 transition cursor-pointer"
        />

        <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
          Form Details Page
        </div>
      </div>

      {/* Premium Info Card - BASIC DETAILS FORM */}
      <div className="bg-white border border-[#38A28D]  rounded-md shadow-sm mb-6 overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100">
          <h2 className="text-lg font-bold text-gray-800 tracking-tight uppercase">
            {getDisplayValue(location.state?.formTitle) ||
              "Carbon Reduction Initiative"}
          </h2>
        </div>
        <div className="p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-[1.6fr_1fr_1fr_1fr] gap-6 xl:gap-8 items-start">
            <div className="space-y-1">
              <p className="text-[15px]  text-[#595F61] uppercase tracking-wider">
                PROJECT
              </p>
              <p className="text-sm font-bold text-gray-800">
                {getDisplayValue(
                  projectDetails?.name || location.state?.projectName,
                ) || "N/A"}
              </p>
            </div>
            <div className="space-y-1">
              <p className="text-[15px]  text-[#595F61] uppercase tracking-wider">
                FREQUENCY
              </p>
              <p className="text-sm font-bold text-gray-800">
                {(() => {
                  const currentFormId = passedFormId || templateId || formId;
                  const allForms = [
                    ...(projectDetails?.standard_form || []),
                    ...(projectDetails?.dynamic_form || []),
                    ...(projectDetails?.custom_form || []),
                  ];
                  const match = allForms.find((f) => f.id === currentFormId);
                  return formatFrequency(match?.frequency || frequecy) || "N/A";
                })()}
              </p>
            </div>
            <div className="space-y-1">
              <p className="text-[15px]  text-[#595F61] uppercase tracking-wider">
                PERIOD
              </p>
              <p className="text-sm font-bold text-gray-800">
                {projectDetails?.year_value || location.state?.period || "N/A"}
              </p>
            </div>
            {/* <div className="space-y-1">
              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">
                END DATE
              </p>
              <p className="text-sm font-bold text-gray-800">
                {details?.endDate || "29 March 2026"}
              </p>
            </div> */}
            <div className="space-y-1">
              <p className="text-[15px]  text-[#595F61] uppercase tracking-wider">
                FORM TYPE
              </p>
              <p className="text-sm font-bold text-gray-800">
                {getDisplayValue(passedFormType || details?.formType) ||
                  "Standard"}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons Row */}
      <div className="flex flex-wrap gap-4 items-center mb-6">
        <button
          onClick={() => {
            if (activeAllotmentMode === "handle") {
              setPopupConfig({
                type: "error",
                title: "Authorization Conflict",
                message:
                  "This form has already been authorized for management and delegation. Users with management authorization are responsible for assigning sections and monitoring progress.",
                confirmText: "Ok",
                widthClass: "sm:w-[480px]",
              });
              return;
            }
            setOpenModal("assign");
          }}
          className="bg-[#06513D] hover:bg-[#387464] text-white px-8 py-2.5 rounded-lg font-bold text-xs  transition-all active:scale-95"
        >
          Assign Form
        </button>
        {/* {allottedByRole !== "L1" && (
          <button
            onClick={async () => {
              if (isEmployeeRoute) {
                setOpenModal("authorize");
                return;
              }
              if (orgModeLocked) {
                setOpenModal("authorize");
                return;
              }
              const hideLoading = message.loading("Checking employee assignments...", 0);
              try {
                const response = await getApi({
                  apiUrl: API_URLS.CHECK_EMPLOYEE_ASSIGNMENTS,
                });

                if (response?.data?.allAssigned) {
                  setOpenModal("authorize");
                } else {
                  message.warning(
                    "Some employees are not assigned to a location or department. Please complete all assignments first."
                  );
                }
              } catch (error) {
                console.error("Assignment check failed:", error);
                message.error("Failed to verify employee assignments.");
              } finally {
                hideLoading();
              }
            }}
            className="bg-white text-[#06513D] border border-[#06513D] px-6 py-2.5 rounded-lg font-bold text-xs flex items-center gap-2 hover:bg-[#06513D]/5 transition-all active:scale-95"
          >
            <GoShieldCheck className="text-lg" /> Authorize to Manage
          </button>
        )} */}

        {allottedByRole !== "L1" && (
          <button
            onClick={async () => {
              if (activeAllotmentMode === "fill") {
                setPopupConfig({
                  type: "error",
                  title: "Assignment Conflict",
                  message:
                    "This form has already been assigned for data entry and cannot be authorized for management at the same time.",
                  confirmText: "Ok",
                  widthClass: "sm:w-[480px]",
                });
                return;
              }
              if (isEmployeeRoute) {
                setOpenModal("authorize");
                return;
              }
              const isLicenseZero =
                projectDetails?.license?.local_supervisor?.unused === 0;

              if (isLicenseZero) {
                setPopupConfig({
                  type: "warning",
                  title: "License Limit Reached",
                  message: "No Local Supervisor License Available",
                });
                return;
              }

              if (!orgModeLocked) {
                setPopupConfig({
                  type: "warning",
                  title: "Organization Setup Incomplete",
                  message:
                    "Your Organization Structure has not been set up. Please setup that first",
                  confirmText: "Setup Organization Structure",
                  onConfirm: () => {
                    setPopupConfig(null);
                    navigate("/organization/organization-setup");
                  },
                  widthClass: "sm:w-[400px] wide-confirm-popup",
                });
                return;
              }

              const hideLoading = message.loading(
                "Checking employee assignments...",
                0,
              );
              try {
                const response = await getApi({
                  apiUrl: API_URLS.CHECK_EMPLOYEE_ASSIGNMENTS,
                });

                if (response?.data?.allAssigned) {
                  setOpenModal("authorize");
                } else {
                  setMappingStats({
                    total: response?.data?.totalEmployees || 0,
                    mapped: response?.data?.assignedCount || 0,
                  });
                  setShowMappingWarning(true);
                }
              } catch (error) {
                console.error("Assignment check failed:", error);
                message.error("Failed to verify employee assignments.");
              } finally {
                hideLoading();
              }
            }}
            className="bg-white text-[#06513D] border border-[#06513D] px-6 py-2.5 rounded-lg font-bold text-xs flex items-center gap-2 hover:bg-[#06513D]/5 transition-all active:scale-95"
          >
            <GoShieldCheck className="text-lg" /> Authorize to Manage
          </button>
        )}
        {!isEmployeeRoute && (
          <button
            onClick={() =>
              navigate(
                `/organization/projects/standard-forms/hierarchy/${formId}`,
              )
            }
            className="bg-[#E6F4EA] text-[#06513D] border border-[#06513D]/20 px-6 py-2.5 rounded-lg font-bold text-xs flex items-center gap-2 hover:bg-[#D7EADD] transition-all"
          >
            <MdOutlineAccountTree className="text-lg" /> View Hierarchy
          </button>
        )}
      </div>

      {/* Tabs System */}
      <div className="bg-white border border-[#38A28D] rounded-2xl overflow-hidden shadow-sm">
        <div className="flex border-b border-gray-100 px-6 pt-2">
          {["Form Structure", "Form Assignments", "Progress & Analytics"].map(
            (tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-8 py-4 text-base font-bold transition-all relative ${
                  activeTab === tab
                    ? "text-[#06513D]"
                    : "text-gray-400 hover:text-gray-600"
                }`}
              >
                {tab}
                {activeTab === tab && (
                  <div className="absolute bottom-[-1px] left-0 w-full h-[3px] bg-[#06513D] rounded-t-full"></div>
                )}
              </button>
            ),
          )}
        </div>

        {/* Tab Content */}
        <div className="">
          {activeTab === "Form Structure" && (
            <div className="p-4">
              <StandardFormAction
                standalone={false}
                formAllotmentId={formAllotmentId}
                userId={getDisplayValue._id}
                templateId={templateId}
                hideBackButton={isStandardViewRoute}
                formType={
                  getDisplayValue(passedFormType || details?.formType) ||
                  "Standard"
                }
              />
            </div>
          )}
          {activeTab === "Form Assignments" && (
            <div className="p-0">
              {reduxLoading ? (
                <div className="flex justify-center items-center py-20">
                  <Spin size="large" />
                </div>
              ) : (
                <Table
                  dataSource={tableData}
                  rowKey={(record) => record.key || record._id}
                  columns={columns.map((col) => ({
                    ...col,
                    title: (
                      <span className="text-xs font-bold text-gray-800 text-center uppercase tracking-tight block w-full">
                        {col.title}
                      </span>
                    ),
                  }))}
                  pagination={false}
                  tableLayout="auto"
                  className="custom-dashboard-table responsive-assignments-table"
                />
              )}

              {/* Pagination Footer */}
              <div className="flex justify-between items-center px-6 py-4 border-t border-gray-100 bg-[#F9FBFC]/30">
                {/* Page size selector */}
                <div className="flex items-center gap-3">
                  <span className="text-xs text-gray-500 font-medium tracking-tight">
                    Showing
                  </span>
                  <select
                    value={pageLimit}
                    onChange={(e) => {
                      const newLimit = Number(e.target.value);
                      setPageLimit(newLimit);
                      setCurrentPage(1);
                      fetchAssignments(1, newLimit);
                    }}
                    className="border border-[#06513D]/20 rounded-lg px-3 py-1 text-xs font-bold text-[#06513D] outline-none bg-white"
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                </div>

                {/* Record count info */}
                <div className="text-xs text-gray-400 font-medium tracking-tight">
                  Showing{" "}
                  {assignmentsTotal === 0
                    ? 0
                    : (currentPage - 1) * pageLimit + 1}{" "}
                  to {Math.min(currentPage * pageLimit, assignmentsTotal)} out
                  of {assignmentsTotal} records
                </div>

                {/* Page buttons */}
                <div className="flex items-center gap-1">
                  {/* Prev */}
                  <button
                    disabled={currentPage === 1}
                    onClick={() => {
                      const newPage = currentPage - 1;
                      setCurrentPage(newPage);
                      fetchAssignments(newPage, pageLimit);
                    }}
                    className="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 text-gray-400 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15 19l-7-7 7-7"
                      />
                    </svg>
                  </button>

                  {/* Page number buttons */}
                  {(() => {
                    const totalPages = Math.ceil(assignmentsTotal / pageLimit);
                    const pages = [];
                    let start = Math.max(1, currentPage - 1);
                    let end = Math.min(totalPages, start + 3);
                    if (end - start < 3) start = Math.max(1, end - 3);

                    for (let i = start; i <= end; i++) {
                      pages.push(
                        <button
                          key={i}
                          onClick={() => {
                            setCurrentPage(i);
                            fetchAssignments(i, pageLimit);
                          }}
                          className={`w-8 h-8 flex items-center justify-center rounded-lg border text-xs font-medium transition-all
                  ${
                    currentPage === i
                      ? "border-[#06513D] bg-white text-[#06513D] font-bold shadow-sm"
                      : "border-transparent text-gray-500 hover:bg-gray-50"
                  }`}
                        >
                          {i}
                        </button>,
                      );
                    }
                    return pages;
                  })()}

                  {/* Next */}
                  <button
                    disabled={
                      currentPage >= Math.ceil(assignmentsTotal / pageLimit)
                    }
                    onClick={() => {
                      const newPage = currentPage + 1;
                      setCurrentPage(newPage);
                      fetchAssignments(newPage, pageLimit);
                    }}
                    className="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 text-gray-400 hover:bg-gray-50 disabled:opacity-40 disabled:cursor-not-allowed"
                  >
                    <svg
                      className="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M9 5l7 7-7 7"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === "Progress & Analytics" && (
            <div className="p-6">
              {loadingProgress ? (
                <div className="flex justify-center items-center py-20">
                  <Spin size="large" />
                </div>
              ) : (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <div className="bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
                      <div className="text-2xl font-black text-[#06513D]">
                        {progressStats.totalAssigned}
                      </div>
                      <div className="text-xs text-gray-400 font-bold uppercase tracking-wider mt-1">
                        Total Assigned Users
                      </div>
                    </div>

                    <div className="bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
                      <div className="text-2xl font-black text-[#06513D]">
                        {progressStats.completedPercent}%
                      </div>
                      <div className="text-[10px] text-gray-400 font-bold uppercase tracking-wider mt-1">
                        Completed ({progressStats.completedCount})
                      </div>
                    </div>

                    <div className="bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
                      <div className="text-2xl font-black text-[#06513D]">
                        {progressStats.inProgressPercent}%
                      </div>
                      <div className="text-[10px] text-gray-400 font-bold uppercase tracking-wider mt-1">
                        In Progress ({progressStats.inProgressCount})
                      </div>
                    </div>

                    <div className="bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
                      <div className="text-2xl font-black text-[#06513D]">
                        {progressStats.pendingPercent}%
                      </div>
                      <div className="text-[10px] text-gray-400 font-bold uppercase tracking-wider mt-1">
                        Not Started ({progressStats.pendingCount})
                      </div>
                    </div>
                  </div>

                  <div className="mt-6 bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
                    <div className="flex items-center justify-between mb-3">
                      <div className="text-sm font-bold text-gray-800">
                        Overall Progress
                      </div>
                      <div className="text-xs text-gray-400 font-bold">
                        {progressStats.completedCount} of{" "}
                        {progressStats.totalAssigned} users completed
                      </div>
                    </div>
                    <div className="w-full h-3 rounded-full bg-gray-200 overflow-hidden flex">
                      <div
                        className="h-full bg-[#06513D]"
                        style={{ width: `${progressStats.completedPercent}%` }}
                      />
                      <div
                        className="h-full bg-[#FBBF24]"
                        style={{ width: `${progressStats.inProgressPercent}%` }}
                      />
                      <div
                        className="h-full bg-[#CBD5E1]"
                        style={{ width: `${progressStats.pendingPercent}%` }}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
      {/* Modals */}
      <Modal
        open={openModal === "authorize"}
        onCancel={() => setOpenModal(null)}
        footer={null}
        width={1400}
        centered
        destroyOnClose={true}
        className="authorize-modal-custom"
        bodyStyle={{ padding: "0", borderRadius: "24px" }}
        maskStyle={{
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(0,0,0,0.4)",
        }}
        closeIcon={
          <div className="bg-white/80 hover:bg-red-50 hover:text-red-500 p-2 rounded-full shadow-sm transition-all absolute right-4 top-4 z-50">
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
        }
      >
        <div className="max-h-[90vh] overflow-y-auto custom-scrollbar p-10 bg-gray-50/50">
          {/* <h2 className="text-2xl font-black text-[#06513D] mb-8 tracking-tight uppercase">
            {shouldUseLs2 ? "Authorize to Manage (LS2)" : "Authorize to Manage"}
          </h2> */}
          {shouldUseLs2 ? (
            <AuthorizeToManageLS2
              formId={passedFormId || formId}
              onClose={() => {
                setOpenModal(null);
                refreshProjectDetails();
              }}
              projectId={projectId}
              locationId={locationId}
              departmentId={departmentId}
              formAllotmentId={resolvedFormAllotmentId}
              formType={details?.formType?.toLowerCase() || "standard"}
            />
          ) : (
            <AuthorizeToManage
              standalone={false}
              onClose={() => {
                setOpenModal(null);
                refreshProjectDetails();
              }}
              projectId={projectId}
              formType={details?.formType?.toLowerCase() || "standard"}
            />
          )}
        </div>
      </Modal>

      <Modal
        open={openModal === "assign"}
        onCancel={() => setOpenModal(null)}
        footer={null}
        width={1200}
        centered
        destroyOnClose={true}
        className="view-standard-form-modal"
        bodyStyle={{ padding: "0", borderRadius: "24px" }}
        maskStyle={{
          backdropFilter: "blur(4px)",
          backgroundColor: "rgba(0,0,0,0.4)",
        }}
        closeIcon={
          <div className="bg-white/80 hover:bg-red-50 hover:text-red-500 p-2 rounded-full shadow-sm transition-all absolute right-4 top-4 z-50">
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </div>
        }
      >
        {/* <div style={scrollableContainer} ref={scrollableContainerRef}>
          {loading ? (
            <div className="flex flex-col gap-4 p-4">
              <Skeleton.Button block active />
              <Skeleton.Button block active />
              <Skeleton.Button block active />
              <Skeleton.Button block active />
            </div>
          ) : selectedSubsection ? (
            <div className="mx-20 shadow-[0_0_16px_0_#3BA2B91F]">
              {questions.length > 0 ? (
                <QuestionUtils
                  questions={questions}
                  expandAll={expandAll}
                  answers={answers}
                  setAnswers={setAnswers}
                  onPrevious={handlePrevious}
                  onNext={handleNext}
                  canGoPrevious={currentSubsectionIndex > 0}
                  canGoNext={currentSubsectionIndex < subsections.length - 1}
                />
              ) : (
                <p className="text-gray-500 text-center p-8">
                  No questions available for this subsection.
                </p>
              )}
            </div>
          ) : (
            <p className="text-gray-500 text-center p-8">
              Please select a subsection to view questions.
            </p>
          )}

          {showGoTop && questions.length > 0 && (
            <Button
              type="primary"
              shape="circle"
              icon={<ArrowUpOutlined />}
              size="large"
              onClick={scrollToTop}
              style={{
                position: "absolute",
                bottom: "30px",
                right: "60px",
                background: "#06513D",
                zIndex: 1000,
                boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
              }}
            />
          )}
        </div> */}
        <div className="max-h-[85vh] overflow-y-auto custom-scrollbar p-10 bg-gray-50/50">
          {/* <div className="mb-8">
                        <h2 className="text-2xl font-black text-gray-800 tracking-tight">Assign Form to Fill</h2>

                    </div> */}
          <AssignFormPage
            standalone={false}
            onClose={() => {
              setOpenModal(null);
              refreshProjectDetails();
            }}
            formId={passedFormId || (isEmployeeRoute ? null : formId)}
            projectId={projectId}
            formName={getDisplayValue(formName || formTitle)}
            roleType={roleType}
            locationId={locationId || locationIdRaw}
            departmentId={departmentId || departmentIdRaw}
            formAllotmentId={resolvedFormAllotmentId}
            formType={passedFormType}
            allotmentType={passedAllotmentType}
            isEmployeeRoute={isEmployeeRoute}
          />
          {/* <div className="flex justify-center mt-8">
                        <button
                            onClick={() => setOpenModal(null)}
                            className="bg-white border border-gray-200 text-gray-600 px-12 py-2.5 rounded-xl font-bold hover:bg-gray-100 transition-all font-[Calibri]"
                        >
                            Close Overlay
                        </button>
                    </div> */}
        </div>
      </Modal>

      {/* Centralized Popup Notification */}
      {popupConfig && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-sm animate-fadeIn">
          <PopupCard
            type={popupConfig.type}
            title={popupConfig.title}
            message={popupConfig.message}
            onConfirm={
              popupConfig.hideConfirm
                ? null
                : popupConfig.onConfirm || (() => setPopupConfig(null))
            }
            onCancel={popupConfig.onCancel}
            confirmText={popupConfig.confirmText || "OK"}
            cancelText={popupConfig.cancelText || "Cancel"}
            widthClass={popupConfig.widthClass || "sm:w-[320px]"}
          />
        </div>
      )}
      {/* Place this just before the closing </div> of the component, alongside other popups */}
      {showMappingWarning && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 animate-fadeIn">
          <div className="w-full max-w-[500px] mx-4 rounded-[20px] overflow-hidden bg-white border border-gray-100 shadow-2xl">
            {/* Amber Header */}
            <div className="bg-[#FAEEDA] px-7 py-6 flex items-start gap-4">
              <div className="flex-shrink-0 w-11 h-11 rounded-full bg-[#EF9F27] flex items-center justify-center">
                <svg
                  width="22"
                  height="22"
                  fill="none"
                  stroke="#FAEEDA"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  viewBox="0 0 24 24"
                >
                  <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
                  <line x1="12" y1="9" x2="12" y2="13" />
                  <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
              </div>
              <div className="flex-1">
                <p className="text-base font-semibold text-[#633806] mb-1">
                  User mapping incomplete
                </p>
                <p className="text-[13px] text-[#854F0B] leading-relaxed">
                  Some users are not yet assigned to a location or department.
                </p>
              </div>
            </div>

            {/* Body */}
            <div className="px-7 pt-6 pb-2">
              <p className="text-[13px] leading-relaxed mb-5">
                Your organization structure is set up, but not all users are
                mapped to a location and department.
              </p>

              {/* Stat Cards */}
              <div className="grid grid-cols-2 gap-3 mb-5">
                <div className="bg-gray-50 border-l-[3px] border-gray-400 pl-4 py-3">
                  <p className="text-[22px] font-medium text-gray-900 leading-none mb-1">
                    {mappingStats.total.toLocaleString()}
                  </p>
                  <p className="text-[11px] uppercase tracking-wider">
                    Total users
                  </p>
                </div>
                <div className="bg-[#FAEEDA] border-l-[3px] border-[#EF9F27] pl-4 py-3">
                  <p className="text-[22px] font-medium text-[#633806] leading-none mb-1">
                    {mappingStats.mapped.toLocaleString()}
                  </p>
                  <p className="text-[11px] uppercase tracking-wider text-[#854F0B]">
                    Mapped users
                  </p>
                </div>
              </div>

              {/* Progress Bar */}
              <div className="rounded-lg px-4 py-3 mb-5">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-[12px]">Mapping progress</span>
                  <span className="text-[12px] font-medium text-[#633806]">
                    {mappingStats.total > 0
                      ? Math.round(
                          (mappingStats.mapped / mappingStats.total) * 100,
                        )
                      : 0}
                    %
                  </span>
                </div>
                <div className="h-[6px] bg-gray-200 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-[#EF9F27] rounded-full transition-all"
                    style={{
                      width: `${
                        mappingStats.total > 0
                          ? Math.round(
                              (mappingStats.mapped / mappingStats.total) * 100,
                            )
                          : 0
                      }%`,
                    }}
                  />
                </div>
              </div>

              {/* Info Note */}
              <div className="flex items-start gap-3 bg-gray-50 rounded-lg px-4 py-3 mb-6">
                <svg
                  width="15"
                  height="15"
                  fill="none"
                  stroke="#000000"
                  strokeWidth="1.5"
                  viewBox="0 0 24 24"
                  className="flex-shrink-0 mt-[2px]"
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
                <p className="text-[12px] leading-relaxed">
                  Only mapped users will be available when authorizing{" "}
                  <span className=" font-medium">
                    Local Supervisor – Location/Department
                  </span>{" "}
                  roles. Complete user mapping for full visibility.
                </p>
              </div>
            </div>

            {/* Footer Buttons */}
            <div className="flex items-center justify-end gap-3 px-4 py-5 border-t border-gray-100">
              <button
                onClick={() => setShowMappingWarning(false)}
                className="px-4 py-2 text-[13px] border border-gray-200 rounded-lg hover:bg-gray-50 transition-all"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  setShowMappingWarning(false);
                  navigate("/organization/user-management"); // 👈 update path
                }}
                className="px-4 py-2 text-[13px] text-[#06513D] border border-[#06513D]/40 rounded-lg hover:bg-[#06513D]/5 transition-all flex items-center gap-2"
              >
                <svg
                  width="13"
                  height="13"
                  fill="none"
                  stroke="#06513D"
                  strokeWidth="1.5"
                  viewBox="0 0 24 24"
                >
                  <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
                  <polyline points="15 3 21 3 21 9" />
                  <line x1="10" y1="14" x2="21" y2="3" />
                </svg>
                Go to user mapping
              </button>
              <button
                onClick={() => {
                  setShowMappingWarning(false);
                  setOpenModal("authorize");
                }}
                className="px-5 py-2 text-[13px] font-semibold text-white bg-[#06513D] rounded-lg hover:bg-[#054031] transition-all active:scale-95"
              >
                Proceed
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Local Styles */}
      <style
        dangerouslySetInnerHTML={{
          __html: `
                    @keyframes fadeIn { from { opacity: 0; transform: translateY(12px); } to { opacity: 1; transform: translateY(0); } }
                    .animate-fadeIn { animation: fadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
                    
                    .custom-dashboard-table .ant-table {
                        background: transparent !important;
                    }
                    .custom-dashboard-table .ant-table-thead > tr > th {
                        background-color: transparent !important;
                        color: #B5B5C3 !important;
                        font-size: 11px !important;
                        font-weight: 800 !important;
                        letter-spacing: 0.08em !important;
                        text-transform: uppercase !important;
                        border-bottom: 2px solid #F8F9FB !important;
                        padding: 24px !important;
                    }
                    .custom-dashboard-table .ant-table-tbody > tr > td {
                        padding: 20px 24px !important;
                        border-bottom: 1px solid #F8F9FB !important;
                        font-size: 14px !important;
                        transition: all 0.2s ease;
                    }
                    .custom-dashboard-table .ant-table-tbody > tr:hover > td {
                        background-color: #F9FBFC !important;
                    }
                    .responsive-assignments-table .ant-table {
                        table-layout: auto !important;
                        width: 100% !important;
                    }
                    .responsive-assignments-table .ant-table-thead > tr > th,
                    .responsive-assignments-table .ant-table-tbody > tr > td {
                        white-space: normal !important;
                        overflow-wrap: anywhere !important;
                        word-break: normal !important;
                    }
                    .responsive-assignments-table .ant-table-thead > tr > th:last-child,
                    .responsive-assignments-table .ant-table-tbody > tr > td:last-child {
                        white-space: nowrap !important;
                        overflow-wrap: normal !important;
                        width: 1%;
                    }
                    @media (max-width: 1024px) {
                        .responsive-assignments-table .ant-table-thead > tr > th,
                        .responsive-assignments-table .ant-table-tbody > tr > td {
                            padding: 14px 12px !important;
                            font-size: 12px !important;
                        }
                    }
                    .custom-scrollbar::-webkit-scrollbar { width: 4px; }
                    .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
                    .custom-scrollbar::-webkit-scrollbar-thumb { background: #CBD5E1; border-radius: 10px; }
                     /* Center DatePicker text and handle minimal icon look */
                    .custom-align-datepicker input {
                        text-align: center !important;
                        cursor: pointer !important;
                        color: #1f2937 !important;
                        font-weight: 500 !important;
                    }
                    .custom-align-datepicker .ant-picker-suffix {
                        opacity: 0;
                        transition: opacity 0.2s ease;
                    }
                    .custom-align-datepicker:hover .ant-picker-suffix {
                        opacity: 1;
                    }

                    /* Active Edit DatePicker Styles to prevent cut-off */
                    .custom-edit-datepicker {
                        padding: 0px 4px !important;
                        border: none !important;
                        background: #f3f4f6 !important;
                        border-radius: 4px !important;
                    }
                    .custom-edit-datepicker .ant-picker-suffix {
                        display: none !important;
                    }
                    .custom-edit-datepicker input {
                        text-align: center !important;
                        font-size: 13px !important;
                        padding: 0 !important;
                        cursor: pointer !important;
                    }
                    /* Modal Ant Design Overrides */
                    .ant-modal-content {
                        border-radius: 24px !important;
                        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15) !important;
                    }
                `,
        }}
      />
    </div>
  );
};

export default ViewStandardForm;
